
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $e1083f20a85be6dc$export$7f1ebd623f131021(size, mapper) {
    return new Array(size).fill(null).map((_, i)=>mapper(i));
}


class $f9d09eeddd0bd49b$export$2e2bcd8739ae039 {
    values;
    size;
    constructor(v){
        if (v instanceof $f9d09eeddd0bd49b$export$2e2bcd8739ae039) {
            this.values = v.values;
            this.size = v.size;
        } else if (v instanceof Array) {
            this.values = new Float16Array(v.length * 2);
            v.forEach((pos, i)=>this.set(i, pos[0], pos[1]));
            this.size = v.length;
        } else if (v instanceof ArrayBuffer) {
            this.values = new Float16Array(v);
            this.size = v.byteLength / 4;
        } else {
            this.size = v;
            this.values = new Float16Array(this.size * 2);
        }
    }
    get buffer() {
        return this.values.buffer;
    }
    copy() {
        return new Float16Array(this.values);
    }
    getX(index) {
        return this.values[index * 2];
    }
    setX(index, value) {
        this.values[index * 2] = value;
    }
    getY(index) {
        return this.values[index * 2 + 1];
    }
    setY(index, value) {
        this.values[index * 2 + 1] = value;
    }
    get(index) {
        return [
            this.getX(index),
            this.getY(index)
        ];
    }
    set(index, x, y) {
        this.setX(index, x);
        this.setY(index, y);
    }
    addVector(index, x, y) {
        this.values[index * 2] += x;
        this.values[index * 2 + 1] += y;
    }
    addX(index, value) {
        this.values[index * 2] += value;
    }
    addY(index, value) {
        this.values[index * 2 + 1] += value;
    }
    subtractX(index, value) {
        this.values[index * 2] -= value;
    }
    subtractY(index, value) {
        this.values[index * 2 + 1] -= value;
    }
    subtractVector(index, x, y) {
        this.values[index * 2] -= x;
        this.values[index * 2 + 1] -= y;
    }
    toCoordinates() {
        return (0, $e1083f20a85be6dc$export$7f1ebd623f131021)(this.size, (i)=>this.get(i));
    }
    forEach(callback) {
        for(let i = 0; i < this.values.length; i += 2)callback(this.values[i], this.values[i + 1], i / 2);
    }
    fill(value) {
        this.values.fill(value);
    }
}


const $07af142d28d528f2$var$DEFAULT_OPTIONS = {
    maxElementsPerQuad: 4,
    position: [
        0,
        0
    ],
    depth: 0,
    minChildWidth: 1
};
class $07af142d28d528f2$export$2e2bcd8739ae039 {
    width;
    elements;
    children;
    options;
    childWidth;
    center;
    weightedCenter;
    isMaxDepth;
    childRects;
    #weight;
    constructor(width, positions, options = {}){
        this.width = width;
        this.childRects = new Map();
        this.options = Object.assign({}, $07af142d28d528f2$var$DEFAULT_OPTIONS, options);
        if (positions) this.addPositions(positions);
    }
    get weight() {
        if (this.#weight == null) {
            if (this.elements) this.#weight = this.elements.length;
            else if (this.children) {
                this.#weight = 0;
                this.children.forEach((child)=>this.#weight += child.weight);
            } else this.#weight = 0;
        }
        return this.#weight;
    }
    push(element) {
        if (this.isMaxDepth || !this.children && (this.elements?.length || 0) < this.options.maxElementsPerQuad) {
            if (!this.elements) this.elements = [
                element
            ];
            else this.elements.push(element);
        } else {
            if (!this.children) this.split();
            if (this.isMaxDepth) this.elements.push(element);
            else this.addElementToZone(element);
        }
    }
    addPositions(positions) {
        const addElements = ()=>{
            if (!this.elements) this.elements = [];
            const startIndex = this.elements.length;
            positions.forEach((x, y, index)=>this.elements.push({
                    coordinates: [
                        x,
                        y
                    ],
                    id: startIndex + index
                }));
        };
        if (this.isMaxDepth || !this.children && (this.elements?.length || 0) + positions.size <= this.options.maxElementsPerQuad) addElements();
        else {
            if (!this.children) this.split();
            if (this.isMaxDepth) addElements();
            else positions.forEach((x, y, index)=>this.addElementToZone({
                    coordinates: [
                        x,
                        y
                    ],
                    id: index
                }));
        }
    }
    getZoneAtPosition(position, createIfNotFound = false) {
        if (!this.children) return null;
        let zone;
        if (position[0] < this.center[0]) zone = position[1] < this.center[1] ? 0 : 3;
        else zone = position[1] < this.center[1] ? 1 : 2;
        if (!this.children.has(zone) && createIfNotFound) this.children.set(zone, new $07af142d28d528f2$export$2e2bcd8739ae039(this.childWidth, null, {
            ...this.options,
            position: this.getPositionForZone(zone),
            depth: this.options.depth + 1
        }));
        return this.children.get(zone);
    }
    addElementToZone(element) {
        // 1. Fine the appropriate zone
        const zone = this.getZoneAtPosition(element.coordinates, true);
        // 2. add the element to the found zone
        zone.push(element);
    }
    split() {
        this.childWidth = this.width / 2;
        if (this.childWidth < this.options.minChildWidth) this.isMaxDepth = true;
        else {
            this.center = this.options.position.map((v)=>v + this.childWidth);
            this.children = new Map();
            if (this.elements) {
                this.elements.forEach((element)=>this.addElementToZone(element));
                this.elements = null;
            }
        }
    }
    getPositionForZone(zoneIndex) {
        switch(zoneIndex){
            case 0:
                return this.options.position;
            case 1:
                return [
                    this.center[0],
                    this.options.position[1]
                ];
            case 2:
                return [
                    this.center[0],
                    this.center[1]
                ];
            case 3:
                return [
                    this.options.position[0],
                    this.center[1]
                ];
            default:
                throw new Error(`Invalid zone index, ${zoneIndex}.`);
        }
    }
    getChildRect(childIndex) {
        if (this.childRects.has(childIndex)) return this.childRects.get(childIndex);
        const isTopRow = childIndex === 0 || childIndex === 1;
        const isLeftColumn = childIndex === 0 || childIndex === 3;
        const rect = {
            width: this.childWidth,
            height: this.childWidth,
            top: isTopRow ? 0 : this.center[1],
            bottom: isTopRow ? this.center[1] : this.width,
            left: isLeftColumn ? 0 : this.center[0],
            right: isLeftColumn ? this.center[0] : this.width
        };
        this.childRects.set(childIndex, rect);
        return rect;
    }
    getElementClosestToPosition(elements, x, y, radius = Infinity) {
        let closestElement;
        for (const element of elements){
            const distance = Math.hypot(Math.abs(x - element.coordinates[0]), Math.abs(y - element.coordinates[1]));
            if (distance <= radius && (!closestElement || closestElement.distance > distance)) closestElement = {
                element: element,
                distance: distance
            };
        }
        return closestElement?.element;
    }
    // Get the element closest to the x/y, within the radius
    findElementAt(x, y, radius = 10) {
        if (this.elements) return this.getElementClosestToPosition(this.elements, x, y, radius);
        else {
            if (this.children) {
                const relevantChildren = this.children.entries().filter(([childIndex])=>{
                    const rect = this.getChildRect(childIndex);
                    const isTopRow = childIndex === 0 || childIndex === 1;
                    const isLeftColumn = childIndex === 0 || childIndex === 3;
                    const fitsX = isLeftColumn ? x < rect.right + radius : x > rect.left - radius;
                    if (fitsX) // If the position is valid on the X axis, return true if it also fits in the Y axis
                    return isTopRow ? y < rect.bottom + radius : y > rect.top - radius;
                });
                const possibleElements = [];
                relevantChildren.forEach(([index, quad])=>{
                    const elementAtPosition = quad.findElementAt(x, y, radius);
                    if (elementAtPosition) possibleElements.push(elementAtPosition);
                });
                return this.getElementClosestToPosition(possibleElements, x, y);
            }
            return null;
        }
    }
    /**
   * Gets the innermost zone that contains the specified position
   * @param position
   * @returns
   */ getZone(position) {
        if (!this.children) return this;
        const zone = this.getZoneAtPosition(position, false);
        return zone.getZone(position);
    }
    getWeightedCenter() {
        if (!this.weightedCenter) {
            if (this.elements) this.weightedCenter = {
                center: this.elements.reduce((avg, { coordinates: coordinates })=>[
                        avg[0] + coordinates[0],
                        avg[1] + coordinates[1]
                    ], [
                    0,
                    0
                ]).map((v)=>v / this.elements.length),
                weight: this.elements.length
            };
            else {
                let wc = {
                    center: [
                        0,
                        0
                    ],
                    weight: 0
                };
                if (this.children) {
                    this.children.forEach((child)=>{
                        const { center: childCenter, weight: childWeight } = child.getWeightedCenter();
                        if (childWeight) wc = {
                            weight: wc.weight + childWeight,
                            center: [
                                wc.center[0] + childCenter[0] * childWeight,
                                wc.center[1] + childCenter[1] * childWeight
                            ]
                        };
                    });
                    this.weightedCenter = {
                        center: [
                            wc.center[0] / wc.weight,
                            wc.center[1] / wc.weight
                        ],
                        weight: wc.weight
                    };
                } else this.weightedCenter = wc;
            }
        }
        return this.weightedCenter;
    }
}


class $91e564d7eb822e04$export$2e2bcd8739ae039 {
    #eventHandlers = {};
    /**
   * Adds an event handler for the specified event
   * @param event
   * @param handler
   * @returns A function that can be called to remove the event handler
   */ on(event, handler) {
        const handlers = this.#eventHandlers[event] ??= [];
        if (!handlers.includes(handler)) handlers.push(handler);
        return ()=>{
            const handlerIndex = handlers.indexOf(handler);
            if (handlerIndex !== -1) handlers.splice(handlerIndex, 1);
        };
    }
    emit(event, payload) {
        this.#eventHandlers[event]?.forEach((handler)=>handler(payload));
    }
}


class $d641d6dd3c1f4acb$export$2e2bcd8739ae039 extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    data;
    constructor(data){
        super();
        this.data = data;
    }
    setData(data) {
        this.data = data;
        this.emit('change', data);
    }
}




class $c80728ab39106c61$export$2e2bcd8739ae039 extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    dataProvider;
    constructor(data){
        super();
        if (data instanceof (0, $d641d6dd3c1f4acb$export$2e2bcd8739ae039)) this.dataProvider = data;
        else this.dataProvider = new (0, $d641d6dd3c1f4acb$export$2e2bcd8739ae039)(data);
    }
    get data() {
        return this.dataProvider.data;
    }
    setData(data) {
        this.dataProvider.setData(data);
    }
}



const $287ee8b0294bddfa$var$goldenRatio = (1 + Math.sqrt(5)) / 2;
const $287ee8b0294bddfa$var$PHYLLOTAXIS_THETA = 2 * Math.PI / $287ee8b0294bddfa$var$goldenRatio;
const $287ee8b0294bddfa$var$DEFAULT_GRAPH_POSITIONS_OPTIONS = {
    randomizeInitialPositions: false,
    gravityCenter: [
        0,
        0
    ],
    positions: null,
    size: 0
};
class $287ee8b0294bddfa$export$2e2bcd8739ae039 extends (0, $f9d09eeddd0bd49b$export$2e2bcd8739ae039) {
    constructor(v = {}){
        if (v instanceof ArrayBuffer) super(v);
        else {
            super(v.positions?.length ?? v.size);
            this.init(Object.assign({}, $287ee8b0294bddfa$var$DEFAULT_GRAPH_POSITIONS_OPTIONS, v));
        }
    }
    init(options) {
        if (options.positions) options.positions.forEach((pos, i)=>this.set(i, pos[0], pos[1]));
        else {
            if (options.randomizeInitialPositions) // Initialize the nodes in the center of the graph and give each of them an initial random velocity, to kick things off
            for(let i = 0; i < this.size; i++)this.set(i, options.gravityCenter[0] + Math.cos(Math.random() * Math.PI * 2) * Math.random() * 200, options.gravityCenter[1] + Math.sin(Math.random() * Math.PI * 2) * Math.random() * 200);
            else {
                const isPhyllotaxis = true;
                if (isPhyllotaxis) this.setPhyllotaxisPositions(this.size, {
                    center: options.gravityCenter,
                    radius: 10
                });
                else {
                    const angle = Math.PI * 2 / this.size;
                    for(let i = 0; i < this.size; i++)this.set(i, options.gravityCenter[0] + 150 * Math.cos(angle * i), options.gravityCenter[1] + 150 * Math.sin(angle * i));
                }
            }
        }
    }
    setPhyllotaxisPositions(n, { radius: radius = 1, center: [cx, cy] = [
        0,
        0
    ], thetaOffset: thetaOffset = 1.49 } = {}) {
        for(let i = 0; i < n; i++){
            const scaledTheta = $287ee8b0294bddfa$var$PHYLLOTAXIS_THETA * i;
            const scaledRadius = radius * Math.sqrt(scaledTheta + thetaOffset);
            this.set(i, Math.cos(scaledTheta) * scaledRadius + cx, Math.sin(scaledTheta) * scaledRadius + cy);
        }
    }
}



class $c5818bfd96ac3b16$export$2e2bcd8739ae039 extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    defaultConfig;
    config;
    constructor(defaultConfig, config = {}){
        super(), this.defaultConfig = defaultConfig;
        this.config = Object.assign({}, defaultConfig, config);
    }
    setConfigValue(key, value, notifyChange = true) {
        if (this.config[key] !== value) {
            const finalValue = value == null ? this.defaultConfig[key] : value;
            this.config[key] = finalValue;
            if (notifyChange) this.emit('change', {
                [key]: finalValue
            });
            return true;
        }
        return false;
    }
}


class $7f69271ec0e296ae$export$2e2bcd8739ae039 extends (0, $c5818bfd96ac3b16$export$2e2bcd8739ae039) {
    constructor(defaultConfig, config = {}){
        super(defaultConfig, config);
    }
}


class $eff8120d33080b89$export$2e2bcd8739ae039 extends (0, $7f69271ec0e296ae$export$2e2bcd8739ae039) {
    center;
    strength;
    constructor(center, strength = 0.1){
        super({}), this.center = center, this.strength = strength;
    }
    apply(positions, forces, fixedPositions) {
        let totalX = 0;
        let totalY = 0;
        positions.forEach((x, y, i)=>{
            if (!fixedPositions.has(i)) {
                totalX += x;
                totalY += y;
            }
        });
        const xStrength = this.strength * (totalX / (positions.size - fixedPositions.size) - this.center[0]);
        const yStrength = this.strength * (totalY / (positions.size - fixedPositions.size) - this.center[1]);
        for(let i = 0; i < positions.size; i++)if (!fixedPositions.has(i)) positions.set(i, positions.getX(i) - xStrength, positions.getY(i) - yStrength);
    }
}



const $24858ececf40e26d$var$DEFAULT_CONFIG = {
    linkLength: 30,
    autoLinkStrength: true,
    linkStrength: 1,
    iterations: 1
};
class $24858ececf40e26d$export$2e2bcd8739ae039 extends (0, $7f69271ec0e296ae$export$2e2bcd8739ae039) {
    data;
    strengths;
    bias;
    constructor(data, config){
        super($24858ececf40e26d$var$DEFAULT_CONFIG, config), this.data = data;
        this.init();
        this.on('change', ()=>this.init());
    }
    init() {
        const linkCountPerNode = new Map();
        for(let i = 0, link; i < this.data.length; i++){
            link = this.data[i];
            const sourceCount = linkCountPerNode.get(link.source);
            const targetCount = linkCountPerNode.get(link.target);
            linkCountPerNode.set(link.source, sourceCount ? sourceCount + 1 : 1);
            linkCountPerNode.set(link.target, targetCount ? targetCount + 1 : 1);
        }
        this.strengths = this.data.map((link)=>this.config.autoLinkStrength ? 1 / Math.min(linkCountPerNode.get(link.source), linkCountPerNode.get(link.target)) : this.config.linkStrength);
        this.bias = this.data.map((link)=>{
            const sourceCount = linkCountPerNode.get(link.source);
            return sourceCount / (sourceCount + linkCountPerNode.get(link.target));
        });
    }
    apply(positions, velocities) {
        for(let k = 0; k < this.config.iterations; k++)for(let i = 0, link; i < this.data.length; i++){
            link = this.data[i];
            const sourcePosition = positions.get(link.source);
            const targetPosition = positions.get(link.target);
            const dx = targetPosition[0] + velocities.getX(link.target) - sourcePosition[0] - velocities.getX(link.source);
            const dy = targetPosition[1] + velocities.getY(link.target) - sourcePosition[1] - velocities.getY(link.source);
            const distance = Math.hypot(dx, dy) || 0.0001; // Avoid division by zero
            // 2. Calculate the "displacement" from the rest length
            // positive = too far (pull), negative = too close (push)
            const diffAndStrength = this.strengths[i] * (distance - this.config.linkLength) / distance;
            const bias = this.bias[i];
            const sourceBias = 1 - bias;
            velocities.addVector(link.source, dx * diffAndStrength * sourceBias, dy * diffAndStrength * sourceBias);
            velocities.subtractVector(link.target, dx * diffAndStrength * bias, dy * diffAndStrength * bias);
        }
    }
}



const $083a4655303fe123$var$DEFAULT_CONFIG = {
    x: 0,
    y: 0,
    strength: 0.1
};
class $083a4655303fe123$export$2e2bcd8739ae039 extends (0, $7f69271ec0e296ae$export$2e2bcd8739ae039) {
    nodes;
    nodesForceX;
    nodesForceY;
    constructor(nodes, config){
        super($083a4655303fe123$var$DEFAULT_CONFIG, config), this.nodes = nodes;
        if (this.config.x instanceof Function) this.nodesForceX = nodes.map(this.config.x);
        if (this.config.y instanceof Function) this.nodesForceY = nodes.map(this.config.y);
    }
    apply(positions, velocities) {
        const getX = this.nodesForceX ? (i)=>this.nodesForceX[i] : ()=>this.config.x;
        const getY = this.nodesForceY ? (i)=>this.nodesForceX[i] : ()=>this.config.y;
        for(let i = 0; i < positions.size; i++){
            velocities.setX(i, velocities.getX(i) + (getX(i) - positions.getX(i)) * this.config.strength);
            velocities.setY(i, velocities.getY(i) + (getY(i) - positions.getY(i)) * this.config.strength);
        }
    }
}



const $625d812715df99ea$var$DEFAULT_CONFIG = {
    radius: 3,
    collisionStrength: 0.1
};
class $625d812715df99ea$export$2e2bcd8739ae039 extends (0, $7f69271ec0e296ae$export$2e2bcd8739ae039) {
    nodesRadius;
    constructor(nodes, nodesRadius, config){
        super($625d812715df99ea$var$DEFAULT_CONFIG, config), this.nodesRadius = nodesRadius;
        const radius = this.config.radius;
        if (!this.nodesRadius && radius instanceof Function) this.nodesRadius = new Float16Array(nodes.map((n)=>radius(n)));
    }
    setNodesRadius(nodesRadius) {
        this.nodesRadius = nodesRadius;
    }
    getNodeRadius(index) {
        // @ts-ignore
        return this.nodesRadius?.[index] ?? this.config.radius;
    }
    apply(positions, velocities, fixedPositions) {
        for(let k = 0; k < 10; k++)for(let i = 0; i < positions.size - 1; i++){
            const nodeX = positions.getX(i) + velocities.getX(i);
            const nodeY = positions.getY(i) + velocities.getY(i);
            for(let j = i + 1; j < positions.size; j++){
                const otherNodeX = positions.getX(j) + velocities.getX(j);
                const otherNodeY = positions.getY(j) + velocities.getY(j);
                let dx = otherNodeX - nodeX || Math.random() * 0.001;
                let dy = otherNodeY - nodeY || Math.random() * 0.001;
                const totalRadiusDistance = this.getNodeRadius(i) + this.getNodeRadius(j);
                const distance = Math.hypot(dx, dy);
                if (distance < totalRadiusDistance) {
                    const distanceIncreaseRatio = totalRadiusDistance / distance;
                    fixedPositions.has(i);
                    const changeDistanceX = dx * (distanceIncreaseRatio - 1) * this.config.collisionStrength;
                    const changeDistanceY = dy * (distanceIncreaseRatio - 1) * this.config.collisionStrength;
                    if (changeDistanceX) {
                        if (fixedPositions.has(i)) // node is to the right of other node
                        velocities.addX(j, changeDistanceX);
                        else if (dx <= 0 && !fixedPositions.has(i) && !fixedPositions.has(j)) // node is to the left of other node
                        velocities.addX(i, changeDistanceX);
                        else velocities.subtractX(i, changeDistanceX);
                    }
                    if (changeDistanceY) {
                        if (fixedPositions.has(i)) // node is to the right of other node
                        velocities.addY(j, changeDistanceY);
                        else if (dy <= 0 && !fixedPositions.has(i) && !fixedPositions.has(j)) // node is to the left of other node
                        velocities.addY(i, changeDistanceY);
                        else velocities.subtractY(i, changeDistanceY);
                    }
                }
            }
        }
    }
}



function $0f6ad5ab5dc125af$export$f39ed087871ad594(vector, mapper) {
    return vector.map(mapper);
}
function $0f6ad5ab5dc125af$export$3ea4ac81884da2c1(coordinates, mapper) {
    return coordinates.map(mapper);
}
function $0f6ad5ab5dc125af$export$c91255cadecfe081(dimensions) {
    return dimensions.map((v)=>v / 2);
}
function $0f6ad5ab5dc125af$export$8c48870e8825fa45(coordinates) {
    if (coordinates.length === 0) throw new Error("Can't get bounding rect, no coordinates specified.");
    if (coordinates.length === 1) return {
        top: coordinates[0][1],
        bottom: coordinates[0][1],
        left: coordinates[0][0],
        right: coordinates[0][0],
        width: 0,
        height: 0
    };
    const sides = coordinates.reduce((box, point)=>({
            top: Math.min(box.top, point[1]),
            bottom: Math.max(box.bottom, point[1]),
            left: Math.min(box.left, point[0]),
            right: Math.max(box.right, point[0])
        }), {
        top: Infinity,
        left: Infinity,
        bottom: -Infinity,
        right: -Infinity
    });
    return {
        ...sides,
        width: sides.right - sides.left,
        height: sides.bottom - sides.top
    };
}
function $0f6ad5ab5dc125af$export$27796bb1a51212b7(c1, c2) {
    return Math.hypot(c2[0] - c1[0], c2[1] - c1[1]);
}
const $0f6ad5ab5dc125af$var$goldenRatio = (1 + Math.sqrt(5)) / 2;
const $0f6ad5ab5dc125af$var$PHYLLOTAXIS_THETA = 2 * Math.PI / $0f6ad5ab5dc125af$var$goldenRatio;
function $0f6ad5ab5dc125af$export$69d2edaed910ac74(n, { radius: radius = 1, center: [cx, cy] = [
    0,
    0
], thetaOffset: thetaOffset = 1.49 } = {}) {
    const positions = new (0, $f9d09eeddd0bd49b$export$2e2bcd8739ae039)(n);
    for(let i = 0; i < n; i++){
        const scaledTheta = $0f6ad5ab5dc125af$var$PHYLLOTAXIS_THETA * i;
        const scaledRadius = radius * Math.sqrt(scaledTheta + thetaOffset);
        positions.setX(i, Math.cos(scaledTheta) * scaledRadius + cx);
        positions.setY(i, Math.sin(scaledTheta) * scaledRadius + cy);
    }
    return positions;
}




const $02230ddf44ec6910$var$DEFAULT_CONFIG = {
    charge: 30,
    useQuadTree: true,
    theta: 1,
    minDistance: 12,
    minQuadSize: 0
};
class $02230ddf44ec6910$export$2e2bcd8739ae039 extends (0, $7f69271ec0e296ae$export$2e2bcd8739ae039) {
    size;
    quadTree;
    constructor(size, config){
        super($02230ddf44ec6910$var$DEFAULT_CONFIG, config), this.size = size;
    }
    apply(positions, velocities, fixedPositions) {
        if (this.config.useQuadTree) this.quadTree = new (0, $07af142d28d528f2$export$2e2bcd8739ae039)(Math.max(...this.size), positions, {
            minChildWidth: this.config.minQuadSize
        });
        for(let i = 0; i < positions.size; i++){
            const isFixed = fixedPositions.has(i);
            const nodePosition = positions.get(i);
            if (this.config.useQuadTree) {
                if (!isFixed) {
                    const generateWeightedCenters = this.generateForceCoordinates(nodePosition, this.quadTree);
                    for (const { center: center, weight: weight } of generateWeightedCenters){
                        const force = this.getForceBetweenNodes(nodePosition, center, this.config.charge * weight, this.config.minDistance);
                        velocities.addVector(i, ...force);
                    }
                }
            } else for(let j = i + 1; j < positions.size; j++){
                const force = this.getForceBetweenNodes(nodePosition, positions.get(j), this.config.charge, this.config.minDistance);
                if (!isFixed) velocities.addVector(i, ...force);
                if (!fixedPositions.has(j)) velocities.subtractVector(j, ...force);
            }
        }
    }
    getForceBetweenNodes(pos1, pos2, charge, minDistance = 0) {
        let dx = pos1[0] - pos2[0];
        let dy = pos1[1] - pos2[1];
        const distance = Math.max(minDistance, Math.hypot(dx, dy));
        // Formula: Force = Strength / distance squared
        // We then divide by distance again to normalize the vector
        const forceMag = charge / distance ** 2;
        // Make sure nodes don't get "stuck" together
        if (dx === 0 && dy === 0) {
            dx = Math.random() * 0.02;
            dy = Math.random() * 0.02;
        }
        return [
            dx * forceMag,
            dy * forceMag
        ];
    }
    /**
   * Get the weighted positions of forces, relative to the given position p
   * @param p
   * @param quadTree
   */ *generateForceCoordinates(p, quadTree) {
        const wc = quadTree.getWeightedCenter();
        if (quadTree.width / (0, $0f6ad5ab5dc125af$export$27796bb1a51212b7)(wc.center, p) < this.config.theta) // Long distance, use the weighed center
        yield wc;
        else {
            // quadtree is near, get its inner forces
            if (quadTree.elements) for (const el of quadTree.elements)yield {
                center: el.coordinates,
                weight: 1
            };
            else {
                for (const child of quadTree.children.values())if (child.weight) yield* this.generateForceCoordinates(p, child);
            }
        }
    }
}


var $6c5a950f6613391e$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};


let $6c5a950f6613391e$var$url = new URL(import.meta.resolve("jbUZ3"));
$6c5a950f6613391e$exports = $56b621a6dd25b2cb$exports($6c5a950f6613391e$var$url.toString(), $6c5a950f6613391e$var$url.origin, true);


class $896623c33dc7f737$export$2e2bcd8739ae039 extends (0, $c80728ab39106c61$export$2e2bcd8739ae039) {
    size;
    nodesRadius;
    config;
    isGenerating;
    positions;
    velocities;
    forces;
    /**
   * Keys are node indexes
   */ fixedPositions;
    isInit;
    alpha;
    quadTree;
    gravityCenter;
    worker;
    isWorker;
    static defaultConfig = {
        charge: 30,
        gravityForce: 0.01,
        minDistance: 12,
        minEnergy: 0.2,
        linkLength: 30,
        friction: 0.4,
        warmupIterations: 20,
        gravityCenter: [
            0.5,
            0.5
        ],
        alphaMin: 0.01,
        alphaDecay: 0.01,
        randomizePositions: false,
        minQuadSize: 2,
        theta: 1,
        useQuadTree: true,
        allowWorker: true,
        animate: true,
        autoLinkStrength: true,
        linkStrength: 1,
        iterations: 1,
        radius: 4,
        collisionStrength: 0.1
    };
    constructor(size, config = {}, data, nodesRadius){
        super(data instanceof (0, $d641d6dd3c1f4acb$export$2e2bcd8739ae039) ? data : new (0, $d641d6dd3c1f4acb$export$2e2bcd8739ae039)(data)), this.size = size, this.nodesRadius = nodesRadius, this.fixedPositions = new Map(), this.isInit = false, this.isWorker = false;
        this.config = Object.assign({}, $896623c33dc7f737$export$2e2bcd8739ae039.defaultConfig, config);
        this.#setGravityCenter();
        this.dataProvider.on('change', (data)=>this.onDataChange(data));
        // this.dataProvider.on('add', e => {
        //   console.log('ADD', e);
        //   this.data.nodes.push(...e);
        //   this.onDataChange(this.data);
        // });
        this.isWorker = self['isGraphWorker'];
    }
    get nodesCount() {
        return this.data?.nodes.length ?? 0;
    }
    setForces() {
        this.forces = [
            this.data.links.length ? new (0, $24858ececf40e26d$export$2e2bcd8739ae039)(this.data.links, this.config) : null,
            new (0, $eff8120d33080b89$export$2e2bcd8739ae039)(this.gravityCenter),
            this.config.gravityForce ? new (0, $083a4655303fe123$export$2e2bcd8739ae039)(this.data.nodes, {
                x: this.size[0] / 2,
                y: this.size[1] / 2,
                strength: this.config.gravityForce
            }) : null,
            this.config.collisionStrength ? new (0, $625d812715df99ea$export$2e2bcd8739ae039)(this.data.nodes, this.nodesRadius, {
                radius: this.config.radius,
                collisionStrength: this.config.collisionStrength
            }) : null,
            this.config.charge ? new (0, $02230ddf44ec6910$export$2e2bcd8739ae039)(this.size, this.config) : null
        ].filter(Boolean);
    }
    setNodesRadius(nodesRadius) {
        this.nodesRadius = nodesRadius;
        this.setForces();
    }
    setSize(size) {
        if (this.size[0] !== size[0] || this.size[1] !== size[1]) {
            this.size = size;
            this.#setGravityCenter();
            this.alpha = 1;
        }
        this.worker?.postMessage({
            type: 'setSize',
            size: size
        });
    }
    #setGravityCenter() {
        this.gravityCenter = [
            this.size[0] * this.config.gravityCenter[0],
            this.size[1] * this.config.gravityCenter[1]
        ];
        this.setForces();
    }
    reset() {
        this.alpha = 1;
        this.isInit = false;
        this.fixedPositions = new Map();
        this.quadTree = null;
        this.worker?.postMessage({
            type: 'reset'
        });
        this.emit('reset', null);
    }
    initPositions() {
        this.positions = new (0, $287ee8b0294bddfa$export$2e2bcd8739ae039)({
            size: this.nodesCount,
            randomizeInitialPositions: this.config.randomizePositions,
            gravityCenter: this.gravityCenter
        });
        this.data.nodes.forEach((node, i)=>{
            if (node.x != null) this.positions.setX(i, node.x * this.size[0]);
            if (node.y != null) this.positions.setY(i, node.y * this.size[1]);
        });
        this.velocities = new (0, $f9d09eeddd0bd49b$export$2e2bcd8739ae039)(this.nodesCount);
        this.isInit = true;
    }
    getNodesRadiusForMessage() {
        const { radius: radius } = this.config;
        return radius instanceof Function ? new Float16Array(this.data.nodes.map((n)=>radius(n))).buffer : null;
    }
    onDataChange(data) {
        this.setForces();
        this.fixedPositions.clear();
        this.alpha = 1;
        this.isInit = false;
        this.quadTree = null;
        this.worker?.postMessage({
            type: 'setData',
            links: data.links,
            nodes: data.nodes,
            nodesRadius: this.getNodesRadiusForMessage()
        });
        this.emit('dataChange', data);
    }
    setConfigValue(key, value, notifyChange = true) {
        if (this.config[key] !== value) {
            this.config[key] = value;
            if (key === 'gravityCenter' || key === 'gravityForce') this.#setGravityCenter();
            // @ts-ignore
            this.forces.forEach((force)=>force.setConfigValue(key, value));
            if (notifyChange) {
                this.alpha = 1;
                this.worker?.postMessage({
                    type: 'setConfigValue',
                    key: key,
                    value: value
                });
                this.emit('configChange', {
                    [key]: value
                });
            }
            return true;
        }
        return false;
    }
    assignConfig(config) {
        let changed = false;
        const changedConfig = {};
        for(const key in config){
            const valueChanged = this.setConfigValue(key, config[key], false);
            changed = changed || valueChanged;
            if (valueChanged) changedConfig[key] = config[key];
        }
        if (changed) {
            this.alpha = 1;
            this.emit('configChange', changedConfig);
        }
    }
    selectNodeAt(x, y, radius = 20) {
        this.createQuadTree();
        const nodeIndex = this.quadTree.findElementAt(x, y, radius)?.id;
        if (nodeIndex != null) return {
            data: this.data.nodes[nodeIndex],
            index: nodeIndex
        };
    }
    fixNodePosition(nodeIndex, x, y) {
        if (this.worker) this.worker.postMessage({
            type: 'fixNodePosition',
            nodeIndex: nodeIndex,
            x: x,
            y: y
        });
        else {
            this.fixedPositions.set(nodeIndex, [
                x,
                y
            ]);
            this.positions.set(nodeIndex, x, y);
            this.velocities.set(nodeIndex, 0, 0);
            this.alpha = 1;
        }
    }
    unfixAllNodePositions() {
        if (this.worker) this.worker.postMessage({
            type: 'unfixAllNodePositions'
        });
        else {
            this.fixedPositions.clear();
            this.alpha = 1;
        }
    }
    unfixNodePosition(nodeIndex) {
        if (this.worker) this.worker.postMessage({
            type: 'unfixNodePosition',
            nodeIndex: nodeIndex
        });
        else {
            this.fixedPositions.delete(nodeIndex);
            this.alpha = 1;
        }
    }
    initWorker() {
        if (!this.worker) {
            this.worker = new Worker($6c5a950f6613391e$exports);
            const { radius: radius } = this.config;
            this.worker.postMessage({
                type: 'init',
                config: {
                    ...this.config,
                    radius: radius instanceof Function ? 0 : radius
                },
                dimensions: this.size,
                links: this.data.links,
                nodes: this.data.nodes,
                nodesRadius: this.getNodesRadiusForMessage()
            });
            this.worker.onmessage = (e)=>this.onWorkerMessage(e);
        }
    }
    onWorkerMessage(e) {
        switch(e.data.type){
            case 'tick':
                this.positions = new (0, $287ee8b0294bddfa$export$2e2bcd8739ae039)(e.data.positions);
                this.emit('tick', null);
                break;
            case 'end':
                this.isGenerating = false;
                break;
        }
    }
    start() {
        if (!this.isWorker && !this.isGenerating) {
            //this.isGenerating = true;
            this.initWorker();
            this.worker.postMessage({
                type: 'start'
            });
        }
    }
    *generate() {
        this.emit('start', null);
        this.isGenerating = true;
        if (!this.isWorker) {
            this.initWorker();
            this.worker.postMessage({
                type: 'start'
            });
            return;
        }
        const velocityDecay = 1 - this.config.friction;
        const allowWarmup = !this.isInit;
        let count = 0;
        if (!this.isInit) {
            this.initPositions();
            this.emit('tick', null);
            count++;
        }
        let totalEnergy = Infinity;
        this.alpha = 1;
        while(totalEnergy > this.config.minEnergy && this.alpha >= this.config.alphaMin && (!this.config.ticks || count < this.config.ticks)){
            totalEnergy = 0;
            this.applyForces();
            for(let nodeIndex = 0; nodeIndex < this.nodesCount; nodeIndex++){
                const velocityX = this.velocities.getX(nodeIndex) * this.alpha * velocityDecay;
                const velocityY = this.velocities.getY(nodeIndex) * this.alpha * velocityDecay;
                this.velocities.set(nodeIndex, velocityX, velocityY);
                if (!this.fixedPositions.has(nodeIndex)) {
                    this.positions.addVector(nodeIndex, velocityX, velocityY);
                    const nodeEnergy = Math.hypot(velocityX, velocityY);
                    if (nodeEnergy > totalEnergy) totalEnergy = nodeEnergy;
                }
            }
            this.alpha += (this.config.alphaMin - this.alpha) * this.config.alphaDecay;
            if (!allowWarmup || count >= this.config.warmupIterations) {
                this.emit('tick', null);
                yield totalEnergy;
            }
            count++;
        }
        this.isGenerating = false;
        this.velocities.fill(0);
        this.emit('stop', null);
    }
    createQuadTree() {
        this.quadTree = new (0, $07af142d28d528f2$export$2e2bcd8739ae039)(Math.max(...this.size), this.positions, {
            minChildWidth: this.config.minQuadSize
        });
    }
    applyForces() {
        if (this.config.useQuadTree) this.createQuadTree();
        this.forces.forEach((force)=>force.apply(this.positions, this.velocities, this.fixedPositions));
    }
}



function $e9091e77072b7374$export$d4ac519fdede4600({ count: count, lightness: lightness = 0.5, saturation: saturation = 1, hueStart: hueStart = 0, hueEnd: hueEnd }) {
    const hueStep = Math.floor(Math.abs(hueEnd ?? hueStart + 360 - hueStart) / count);
    return (0, $e1083f20a85be6dc$export$7f1ebd623f131021)(count, (i)=>`hsl(${(hueStart + i * hueStep) % 360},${saturation * 100}%,${lightness * 100}%)`);
}



class $9936be7d63e3034a$export$2e2bcd8739ae039 extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    parentElement;
    options;
    element;
    size;
    isResizeFirstTime;
    removeOnResizeListener;
    constructor(parentElement, options = {}){
        super(), this.parentElement = parentElement, this.options = options, this.size = [
            0,
            0
        ], this.isResizeFirstTime = true;
        const rect = this.parentElement.getBoundingClientRect();
        this.size = [
            rect.width,
            rect.height
        ];
        this.setOnResize();
    }
    getSize() {
        return this.size;
    }
    setOnResize() {
        const resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries){
                if (!this.isResizeFirstTime) {
                    if (!this.options.isFixedSize) this.emit('resize', this.size = [
                        entry.contentRect.width,
                        entry.contentRect.height
                    ]);
                }
                this.isResizeFirstTime = false;
            }
        });
        this.removeOnResizeListener = ()=>resizeObserver.disconnect();
        resizeObserver.observe(this.parentElement);
    }
}


class $d45f09bc4feaf860$export$2e2bcd8739ae039 extends (0, $9936be7d63e3034a$export$2e2bcd8739ae039) {
    canvas;
    ctx;
    constructor(parentElement, options = {}){
        super(parentElement, options);
        const canvas = this.canvas = document.createElement('canvas');
        this.parentElement.appendChild(canvas);
        this.ctx = canvas.getContext('2d');
        this.setCanvasSize(this.size);
        this.element = canvas;
        canvas.style.touchAction = 'none';
        this.on('resize', (size)=>this.setCanvasSize(size));
    }
    setCanvasSize(size) {
        const dpi = devicePixelRatio;
        this.canvas.width = size[0] * dpi;
        this.canvas.height = size[1] * dpi;
        this.canvas.style.setProperty('width', `${size[0]}px`);
        this.canvas.style.setProperty('height', `${size[1]}px`);
        this.ctx.scale(devicePixelRatio, devicePixelRatio);
    }
    clear() {
        this.ctx.clearRect(0, 0, ...this.size);
    }
    drawCircle(center, radius, color, stroke = false) {
        if (color) this.ctx.fillStyle = color;
        this.ctx.beginPath();
        this.ctx.moveTo(center[0] + radius, center[1]);
        this.ctx.arc(...center, radius, 0, Math.PI * 2);
        if (stroke) this.ctx.stroke();
        this.ctx.fill();
    }
    drawLine(from, to) {
        this.ctx.beginPath();
        this.ctx.moveTo(...from);
        this.ctx.lineTo(...to);
        this.ctx.stroke();
    }
    drawLines(positions) {
        this.ctx.beginPath();
        for (const pair of positions){
            this.ctx.moveTo(...pair[0]);
            this.ctx.lineTo(...pair[1]);
        }
        this.ctx.stroke();
    }
    drawText(position, text, font = '14px Arial') {
        this.ctx.font = font;
        this.ctx.fillText(text, position[0], position[1]);
    }
    setFillColor(fill) {
        this.ctx.fillStyle = fill;
    }
    setLineColor(color) {
        this.ctx.strokeStyle = color;
    }
    setLineWidth(width) {
        this.ctx.lineWidth = width;
    }
}


function $1f64d56da139e45b$export$a09fe9e8bf25e81c(data, dimension) {
    const dimensionMap = new Map();
    data.forEach((d)=>{
        const value = d[dimension];
        if (!dimensionMap.has(value)) dimensionMap.set(value, dimensionMap.size);
    });
    return dimensionMap;
}



const $b8d9a51bf7bf18e2$export$80ded914badbe643 = {
    nodeRadius: 4,
    linkWidth: 0.5,
    linkColor: '#999999',
    nodeColor: 'black',
    nodeColorDimension: null,
    fixNodesOnDrag: false
};


function $bcff7b84e16a8e00$export$bf7199a9ebcb84a9(valueOrFunction, params) {
    return valueOrFunction instanceof Function ? valueOrFunction(params) : valueOrFunction;
}


class $326a3135f3ea9288$export$2e2bcd8739ae039 extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    graph;
    renderer;
    config;
    raf;
    getNodeColor;
    selectedNodeIndex;
    constructor(graph, parentElement, config = {}){
        super(), this.graph = graph;
        this.renderer = new (0, $d45f09bc4feaf860$export$2e2bcd8739ae039)(parentElement);
        this.config = Object.assign({}, (0, $b8d9a51bf7bf18e2$export$80ded914badbe643), config);
        this.setNodeColors();
        graph.on('configChange', ()=>{
            if (!graph.isGenerating) this.render();
        });
        graph.on('dataChange', (data)=>{
            this.setNodeColors();
            this.render();
        });
        graph.on('reset', ()=>this.render());
        graph.on('tick', ()=>{
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(()=>this.draw());
        });
        if (graph.data) this.render();
        const onMouseMove = (e)=>{
            graph.fixNodePosition(this.selectedNodeIndex, e.x, e.y);
        };
        this.renderer.on('resize', (size)=>{
            graph.setSize(size);
            this.draw();
            if (!graph.isGenerating) this.render();
        });
        this.renderer.element.addEventListener('pointerup', ()=>{
            this.renderer.element.removeEventListener('pointermove', onMouseMove);
            if (!this.config.fixNodesOnDrag) graph.unfixNodePosition(this.selectedNodeIndex);
            this.selectedNodeIndex = null;
        });
        this.renderer.element.addEventListener('pointerdown', (e)=>{
            const position = graph.selectNodeAt(e.x, e.y, 30);
            if (position) {
                if (e.ctrlKey) graph.unfixNodePosition(position.index);
                else {
                    this.selectedNodeIndex = position.index;
                    this.renderer.element.addEventListener('pointermove', onMouseMove);
                }
            } else this.emit('click', {
                x: e.x,
                y: e.y
            });
        });
    }
    setNodeColors() {
        if (this.config.nodeColorDimension && this.graph.data) {
            const nodeColorsMap = (0, $1f64d56da139e45b$export$a09fe9e8bf25e81c)(this.graph.data.nodes, this.config.nodeColorDimension);
            const colors = (0, $e9091e77072b7374$export$d4ac519fdede4600)({
                count: nodeColorsMap.size,
                hueStart: 190,
                lightness: 0.45
            });
            this.getNodeColor = (node)=>colors[nodeColorsMap.get(node[this.config.nodeColorDimension])];
        } else this.getNodeColor = ()=>this.config.nodeColor ?? 'black';
    }
    setConfigValue(key, value) {
        if (this.config[key] !== value) {
            this.config[key] = value;
            this.draw();
        }
    }
    render() {
        if (!this.graph.isGenerating) this.graph.start();
    }
    draw() {
        this.renderer.clear();
        this.renderer.setLineColor(this.config.linkColor);
        this.renderer.setLineWidth(this.config.linkWidth);
        this.graph.data.links.forEach((link)=>{
            this.renderer.drawLine(this.graph.positions.get(link.source), this.graph.positions.get(link.target));
        });
        this.renderer.setLineWidth(2);
        this.graph.data.nodes.forEach((node, i)=>{
            const position = this.graph.positions.get(i);
            this.renderer.setLineColor(i === this.selectedNodeIndex ? 'black' : 'white');
            const radius = (0, $bcff7b84e16a8e00$export$bf7199a9ebcb84a9)(this.graph.config.radius, node);
            this.renderer.drawCircle(position, //Math.max(node.radius ?? this.config.nodeRadius),
            radius - 1, this.getNodeColor(node), true);
        // this.renderer.setFillColor('#000000');
        // this.renderer.drawText(position, String(i));
        });
    }
}


var $610202b23933f097$exports = {};
$610202b23933f097$exports = JSON.parse("{\"nodes\":[{\"id\":\"Myriel\",\"group\":1},{\"id\":\"Napoleon\",\"group\":1},{\"id\":\"Mlle.Baptistine\",\"group\":1},{\"id\":\"Mme.Magloire\",\"group\":1},{\"id\":\"CountessdeLo\",\"group\":1},{\"id\":\"Geborand\",\"group\":1},{\"id\":\"Champtercier\",\"group\":1},{\"id\":\"Cravatte\",\"group\":1},{\"id\":\"Count\",\"group\":1},{\"id\":\"OldMan\",\"group\":1},{\"id\":\"Labarre\",\"group\":2},{\"id\":\"Valjean\",\"group\":2},{\"id\":\"Marguerite\",\"group\":3},{\"id\":\"Mme.deR\",\"group\":2},{\"id\":\"Isabeau\",\"group\":2},{\"id\":\"Gervais\",\"group\":2},{\"id\":\"Tholomyes\",\"group\":3},{\"id\":\"Listolier\",\"group\":3},{\"id\":\"Fameuil\",\"group\":3},{\"id\":\"Blacheville\",\"group\":3},{\"id\":\"Favourite\",\"group\":3},{\"id\":\"Dahlia\",\"group\":3},{\"id\":\"Zephine\",\"group\":3},{\"id\":\"Fantine\",\"group\":3},{\"id\":\"Mme.Thenardier\",\"group\":4},{\"id\":\"Thenardier\",\"group\":4},{\"id\":\"Cosette\",\"group\":5},{\"id\":\"Javert\",\"group\":4},{\"id\":\"Fauchelevent\",\"group\":0},{\"id\":\"Bamatabois\",\"group\":2},{\"id\":\"Perpetue\",\"group\":3},{\"id\":\"Simplice\",\"group\":2},{\"id\":\"Scaufflaire\",\"group\":2},{\"id\":\"Woman1\",\"group\":2},{\"id\":\"Judge\",\"group\":2},{\"id\":\"Champmathieu\",\"group\":2},{\"id\":\"Brevet\",\"group\":2},{\"id\":\"Chenildieu\",\"group\":2},{\"id\":\"Cochepaille\",\"group\":2},{\"id\":\"Pontmercy\",\"group\":4},{\"id\":\"Boulatruelle\",\"group\":6},{\"id\":\"Eponine\",\"group\":4},{\"id\":\"Anzelma\",\"group\":4},{\"id\":\"Woman2\",\"group\":5},{\"id\":\"MotherInnocent\",\"group\":0},{\"id\":\"Gribier\",\"group\":0},{\"id\":\"Jondrette\",\"group\":7},{\"id\":\"Mme.Burgon\",\"group\":7},{\"id\":\"Gavroche\",\"group\":8},{\"id\":\"Gillenormand\",\"group\":5},{\"id\":\"Magnon\",\"group\":5},{\"id\":\"Mlle.Gillenormand\",\"group\":5},{\"id\":\"Mme.Pontmercy\",\"group\":5},{\"id\":\"Mlle.Vaubois\",\"group\":5},{\"id\":\"Lt.Gillenormand\",\"group\":5},{\"id\":\"Marius\",\"group\":8},{\"id\":\"BaronessT\",\"group\":5},{\"id\":\"Mabeuf\",\"group\":8},{\"id\":\"Enjolras\",\"group\":8},{\"id\":\"Combeferre\",\"group\":8},{\"id\":\"Prouvaire\",\"group\":8},{\"id\":\"Feuilly\",\"group\":8},{\"id\":\"Courfeyrac\",\"group\":8},{\"id\":\"Bahorel\",\"group\":8},{\"id\":\"Bossuet\",\"group\":8},{\"id\":\"Joly\",\"group\":8},{\"id\":\"Grantaire\",\"group\":8},{\"id\":\"MotherPlutarch\",\"group\":9},{\"id\":\"Gueulemer\",\"group\":4},{\"id\":\"Babet\",\"group\":4},{\"id\":\"Claquesous\",\"group\":4},{\"id\":\"Montparnasse\",\"group\":4},{\"id\":\"Toussaint\",\"group\":5},{\"id\":\"Child1\",\"group\":10},{\"id\":\"Child2\",\"group\":10},{\"id\":\"Brujon\",\"group\":4},{\"id\":\"Mme.Hucheloup\",\"group\":8}],\"links\":[{\"source\":\"Napoleon\",\"target\":\"Myriel\",\"value\":1},{\"source\":\"Mlle.Baptistine\",\"target\":\"Myriel\",\"value\":8},{\"source\":\"Mme.Magloire\",\"target\":\"Myriel\",\"value\":10},{\"source\":\"Mme.Magloire\",\"target\":\"Mlle.Baptistine\",\"value\":6},{\"source\":\"CountessdeLo\",\"target\":\"Myriel\",\"value\":1},{\"source\":\"Geborand\",\"target\":\"Myriel\",\"value\":1},{\"source\":\"Champtercier\",\"target\":\"Myriel\",\"value\":1},{\"source\":\"Cravatte\",\"target\":\"Myriel\",\"value\":1},{\"source\":\"Count\",\"target\":\"Myriel\",\"value\":2},{\"source\":\"OldMan\",\"target\":\"Myriel\",\"value\":1},{\"source\":\"Valjean\",\"target\":\"Labarre\",\"value\":1},{\"source\":\"Valjean\",\"target\":\"Mme.Magloire\",\"value\":3},{\"source\":\"Valjean\",\"target\":\"Mlle.Baptistine\",\"value\":3},{\"source\":\"Valjean\",\"target\":\"Myriel\",\"value\":5},{\"source\":\"Marguerite\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Mme.deR\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Isabeau\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Gervais\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Listolier\",\"target\":\"Tholomyes\",\"value\":4},{\"source\":\"Fameuil\",\"target\":\"Tholomyes\",\"value\":4},{\"source\":\"Fameuil\",\"target\":\"Listolier\",\"value\":4},{\"source\":\"Blacheville\",\"target\":\"Tholomyes\",\"value\":4},{\"source\":\"Blacheville\",\"target\":\"Listolier\",\"value\":4},{\"source\":\"Blacheville\",\"target\":\"Fameuil\",\"value\":4},{\"source\":\"Favourite\",\"target\":\"Tholomyes\",\"value\":3},{\"source\":\"Favourite\",\"target\":\"Listolier\",\"value\":3},{\"source\":\"Favourite\",\"target\":\"Fameuil\",\"value\":3},{\"source\":\"Favourite\",\"target\":\"Blacheville\",\"value\":4},{\"source\":\"Dahlia\",\"target\":\"Tholomyes\",\"value\":3},{\"source\":\"Dahlia\",\"target\":\"Listolier\",\"value\":3},{\"source\":\"Dahlia\",\"target\":\"Fameuil\",\"value\":3},{\"source\":\"Dahlia\",\"target\":\"Blacheville\",\"value\":3},{\"source\":\"Dahlia\",\"target\":\"Favourite\",\"value\":5},{\"source\":\"Zephine\",\"target\":\"Tholomyes\",\"value\":3},{\"source\":\"Zephine\",\"target\":\"Listolier\",\"value\":3},{\"source\":\"Zephine\",\"target\":\"Fameuil\",\"value\":3},{\"source\":\"Zephine\",\"target\":\"Blacheville\",\"value\":3},{\"source\":\"Zephine\",\"target\":\"Favourite\",\"value\":4},{\"source\":\"Zephine\",\"target\":\"Dahlia\",\"value\":4},{\"source\":\"Fantine\",\"target\":\"Tholomyes\",\"value\":3},{\"source\":\"Fantine\",\"target\":\"Listolier\",\"value\":3},{\"source\":\"Fantine\",\"target\":\"Fameuil\",\"value\":3},{\"source\":\"Fantine\",\"target\":\"Blacheville\",\"value\":3},{\"source\":\"Fantine\",\"target\":\"Favourite\",\"value\":4},{\"source\":\"Fantine\",\"target\":\"Dahlia\",\"value\":4},{\"source\":\"Fantine\",\"target\":\"Zephine\",\"value\":4},{\"source\":\"Fantine\",\"target\":\"Marguerite\",\"value\":2},{\"source\":\"Fantine\",\"target\":\"Valjean\",\"value\":9},{\"source\":\"Mme.Thenardier\",\"target\":\"Fantine\",\"value\":2},{\"source\":\"Mme.Thenardier\",\"target\":\"Valjean\",\"value\":7},{\"source\":\"Thenardier\",\"target\":\"Mme.Thenardier\",\"value\":13},{\"source\":\"Thenardier\",\"target\":\"Fantine\",\"value\":1},{\"source\":\"Thenardier\",\"target\":\"Valjean\",\"value\":12},{\"source\":\"Cosette\",\"target\":\"Mme.Thenardier\",\"value\":4},{\"source\":\"Cosette\",\"target\":\"Valjean\",\"value\":31},{\"source\":\"Cosette\",\"target\":\"Tholomyes\",\"value\":1},{\"source\":\"Cosette\",\"target\":\"Thenardier\",\"value\":1},{\"source\":\"Javert\",\"target\":\"Valjean\",\"value\":17},{\"source\":\"Javert\",\"target\":\"Fantine\",\"value\":5},{\"source\":\"Javert\",\"target\":\"Thenardier\",\"value\":5},{\"source\":\"Javert\",\"target\":\"Mme.Thenardier\",\"value\":1},{\"source\":\"Javert\",\"target\":\"Cosette\",\"value\":1},{\"source\":\"Fauchelevent\",\"target\":\"Valjean\",\"value\":8},{\"source\":\"Fauchelevent\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Bamatabois\",\"target\":\"Fantine\",\"value\":1},{\"source\":\"Bamatabois\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Bamatabois\",\"target\":\"Valjean\",\"value\":2},{\"source\":\"Perpetue\",\"target\":\"Fantine\",\"value\":1},{\"source\":\"Simplice\",\"target\":\"Perpetue\",\"value\":2},{\"source\":\"Simplice\",\"target\":\"Valjean\",\"value\":3},{\"source\":\"Simplice\",\"target\":\"Fantine\",\"value\":2},{\"source\":\"Simplice\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Scaufflaire\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Woman1\",\"target\":\"Valjean\",\"value\":2},{\"source\":\"Woman1\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Judge\",\"target\":\"Valjean\",\"value\":3},{\"source\":\"Judge\",\"target\":\"Bamatabois\",\"value\":2},{\"source\":\"Champmathieu\",\"target\":\"Valjean\",\"value\":3},{\"source\":\"Champmathieu\",\"target\":\"Judge\",\"value\":3},{\"source\":\"Champmathieu\",\"target\":\"Bamatabois\",\"value\":2},{\"source\":\"Brevet\",\"target\":\"Judge\",\"value\":2},{\"source\":\"Brevet\",\"target\":\"Champmathieu\",\"value\":2},{\"source\":\"Brevet\",\"target\":\"Valjean\",\"value\":2},{\"source\":\"Brevet\",\"target\":\"Bamatabois\",\"value\":1},{\"source\":\"Chenildieu\",\"target\":\"Judge\",\"value\":2},{\"source\":\"Chenildieu\",\"target\":\"Champmathieu\",\"value\":2},{\"source\":\"Chenildieu\",\"target\":\"Brevet\",\"value\":2},{\"source\":\"Chenildieu\",\"target\":\"Valjean\",\"value\":2},{\"source\":\"Chenildieu\",\"target\":\"Bamatabois\",\"value\":1},{\"source\":\"Cochepaille\",\"target\":\"Judge\",\"value\":2},{\"source\":\"Cochepaille\",\"target\":\"Champmathieu\",\"value\":2},{\"source\":\"Cochepaille\",\"target\":\"Brevet\",\"value\":2},{\"source\":\"Cochepaille\",\"target\":\"Chenildieu\",\"value\":2},{\"source\":\"Cochepaille\",\"target\":\"Valjean\",\"value\":2},{\"source\":\"Cochepaille\",\"target\":\"Bamatabois\",\"value\":1},{\"source\":\"Pontmercy\",\"target\":\"Thenardier\",\"value\":1},{\"source\":\"Boulatruelle\",\"target\":\"Thenardier\",\"value\":1},{\"source\":\"Eponine\",\"target\":\"Mme.Thenardier\",\"value\":2},{\"source\":\"Eponine\",\"target\":\"Thenardier\",\"value\":3},{\"source\":\"Anzelma\",\"target\":\"Eponine\",\"value\":2},{\"source\":\"Anzelma\",\"target\":\"Thenardier\",\"value\":2},{\"source\":\"Anzelma\",\"target\":\"Mme.Thenardier\",\"value\":1},{\"source\":\"Woman2\",\"target\":\"Valjean\",\"value\":3},{\"source\":\"Woman2\",\"target\":\"Cosette\",\"value\":1},{\"source\":\"Woman2\",\"target\":\"Javert\",\"value\":1},{\"source\":\"MotherInnocent\",\"target\":\"Fauchelevent\",\"value\":3},{\"source\":\"MotherInnocent\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Gribier\",\"target\":\"Fauchelevent\",\"value\":2},{\"source\":\"Mme.Burgon\",\"target\":\"Jondrette\",\"value\":1},{\"source\":\"Gavroche\",\"target\":\"Mme.Burgon\",\"value\":2},{\"source\":\"Gavroche\",\"target\":\"Thenardier\",\"value\":1},{\"source\":\"Gavroche\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Gavroche\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Gillenormand\",\"target\":\"Cosette\",\"value\":3},{\"source\":\"Gillenormand\",\"target\":\"Valjean\",\"value\":2},{\"source\":\"Magnon\",\"target\":\"Gillenormand\",\"value\":1},{\"source\":\"Magnon\",\"target\":\"Mme.Thenardier\",\"value\":1},{\"source\":\"Mlle.Gillenormand\",\"target\":\"Gillenormand\",\"value\":9},{\"source\":\"Mlle.Gillenormand\",\"target\":\"Cosette\",\"value\":2},{\"source\":\"Mlle.Gillenormand\",\"target\":\"Valjean\",\"value\":2},{\"source\":\"Mme.Pontmercy\",\"target\":\"Mlle.Gillenormand\",\"value\":1},{\"source\":\"Mme.Pontmercy\",\"target\":\"Pontmercy\",\"value\":1},{\"source\":\"Mlle.Vaubois\",\"target\":\"Mlle.Gillenormand\",\"value\":1},{\"source\":\"Lt.Gillenormand\",\"target\":\"Mlle.Gillenormand\",\"value\":2},{\"source\":\"Lt.Gillenormand\",\"target\":\"Gillenormand\",\"value\":1},{\"source\":\"Lt.Gillenormand\",\"target\":\"Cosette\",\"value\":1},{\"source\":\"Marius\",\"target\":\"Mlle.Gillenormand\",\"value\":6},{\"source\":\"Marius\",\"target\":\"Gillenormand\",\"value\":12},{\"source\":\"Marius\",\"target\":\"Pontmercy\",\"value\":1},{\"source\":\"Marius\",\"target\":\"Lt.Gillenormand\",\"value\":1},{\"source\":\"Marius\",\"target\":\"Cosette\",\"value\":21},{\"source\":\"Marius\",\"target\":\"Valjean\",\"value\":19},{\"source\":\"Marius\",\"target\":\"Tholomyes\",\"value\":1},{\"source\":\"Marius\",\"target\":\"Thenardier\",\"value\":2},{\"source\":\"Marius\",\"target\":\"Eponine\",\"value\":5},{\"source\":\"Marius\",\"target\":\"Gavroche\",\"value\":4},{\"source\":\"BaronessT\",\"target\":\"Gillenormand\",\"value\":1},{\"source\":\"BaronessT\",\"target\":\"Marius\",\"value\":1},{\"source\":\"Mabeuf\",\"target\":\"Marius\",\"value\":1},{\"source\":\"Mabeuf\",\"target\":\"Eponine\",\"value\":1},{\"source\":\"Mabeuf\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Enjolras\",\"target\":\"Marius\",\"value\":7},{\"source\":\"Enjolras\",\"target\":\"Gavroche\",\"value\":7},{\"source\":\"Enjolras\",\"target\":\"Javert\",\"value\":6},{\"source\":\"Enjolras\",\"target\":\"Mabeuf\",\"value\":1},{\"source\":\"Enjolras\",\"target\":\"Valjean\",\"value\":4},{\"source\":\"Combeferre\",\"target\":\"Enjolras\",\"value\":15},{\"source\":\"Combeferre\",\"target\":\"Marius\",\"value\":5},{\"source\":\"Combeferre\",\"target\":\"Gavroche\",\"value\":6},{\"source\":\"Combeferre\",\"target\":\"Mabeuf\",\"value\":2},{\"source\":\"Prouvaire\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Prouvaire\",\"target\":\"Enjolras\",\"value\":4},{\"source\":\"Prouvaire\",\"target\":\"Combeferre\",\"value\":2},{\"source\":\"Feuilly\",\"target\":\"Gavroche\",\"value\":2},{\"source\":\"Feuilly\",\"target\":\"Enjolras\",\"value\":6},{\"source\":\"Feuilly\",\"target\":\"Prouvaire\",\"value\":2},{\"source\":\"Feuilly\",\"target\":\"Combeferre\",\"value\":5},{\"source\":\"Feuilly\",\"target\":\"Mabeuf\",\"value\":1},{\"source\":\"Feuilly\",\"target\":\"Marius\",\"value\":1},{\"source\":\"Courfeyrac\",\"target\":\"Marius\",\"value\":9},{\"source\":\"Courfeyrac\",\"target\":\"Enjolras\",\"value\":17},{\"source\":\"Courfeyrac\",\"target\":\"Combeferre\",\"value\":13},{\"source\":\"Courfeyrac\",\"target\":\"Gavroche\",\"value\":7},{\"source\":\"Courfeyrac\",\"target\":\"Mabeuf\",\"value\":2},{\"source\":\"Courfeyrac\",\"target\":\"Eponine\",\"value\":1},{\"source\":\"Courfeyrac\",\"target\":\"Feuilly\",\"value\":6},{\"source\":\"Courfeyrac\",\"target\":\"Prouvaire\",\"value\":3},{\"source\":\"Bahorel\",\"target\":\"Combeferre\",\"value\":5},{\"source\":\"Bahorel\",\"target\":\"Gavroche\",\"value\":5},{\"source\":\"Bahorel\",\"target\":\"Courfeyrac\",\"value\":6},{\"source\":\"Bahorel\",\"target\":\"Mabeuf\",\"value\":2},{\"source\":\"Bahorel\",\"target\":\"Enjolras\",\"value\":4},{\"source\":\"Bahorel\",\"target\":\"Feuilly\",\"value\":3},{\"source\":\"Bahorel\",\"target\":\"Prouvaire\",\"value\":2},{\"source\":\"Bahorel\",\"target\":\"Marius\",\"value\":1},{\"source\":\"Bossuet\",\"target\":\"Marius\",\"value\":5},{\"source\":\"Bossuet\",\"target\":\"Courfeyrac\",\"value\":12},{\"source\":\"Bossuet\",\"target\":\"Gavroche\",\"value\":5},{\"source\":\"Bossuet\",\"target\":\"Bahorel\",\"value\":4},{\"source\":\"Bossuet\",\"target\":\"Enjolras\",\"value\":10},{\"source\":\"Bossuet\",\"target\":\"Feuilly\",\"value\":6},{\"source\":\"Bossuet\",\"target\":\"Prouvaire\",\"value\":2},{\"source\":\"Bossuet\",\"target\":\"Combeferre\",\"value\":9},{\"source\":\"Bossuet\",\"target\":\"Mabeuf\",\"value\":1},{\"source\":\"Bossuet\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Joly\",\"target\":\"Bahorel\",\"value\":5},{\"source\":\"Joly\",\"target\":\"Bossuet\",\"value\":7},{\"source\":\"Joly\",\"target\":\"Gavroche\",\"value\":3},{\"source\":\"Joly\",\"target\":\"Courfeyrac\",\"value\":5},{\"source\":\"Joly\",\"target\":\"Enjolras\",\"value\":5},{\"source\":\"Joly\",\"target\":\"Feuilly\",\"value\":5},{\"source\":\"Joly\",\"target\":\"Prouvaire\",\"value\":2},{\"source\":\"Joly\",\"target\":\"Combeferre\",\"value\":5},{\"source\":\"Joly\",\"target\":\"Mabeuf\",\"value\":1},{\"source\":\"Joly\",\"target\":\"Marius\",\"value\":2},{\"source\":\"Grantaire\",\"target\":\"Bossuet\",\"value\":3},{\"source\":\"Grantaire\",\"target\":\"Enjolras\",\"value\":3},{\"source\":\"Grantaire\",\"target\":\"Combeferre\",\"value\":1},{\"source\":\"Grantaire\",\"target\":\"Courfeyrac\",\"value\":2},{\"source\":\"Grantaire\",\"target\":\"Joly\",\"value\":2},{\"source\":\"Grantaire\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Grantaire\",\"target\":\"Bahorel\",\"value\":1},{\"source\":\"Grantaire\",\"target\":\"Feuilly\",\"value\":1},{\"source\":\"Grantaire\",\"target\":\"Prouvaire\",\"value\":1},{\"source\":\"MotherPlutarch\",\"target\":\"Mabeuf\",\"value\":3},{\"source\":\"Gueulemer\",\"target\":\"Thenardier\",\"value\":5},{\"source\":\"Gueulemer\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Gueulemer\",\"target\":\"Mme.Thenardier\",\"value\":1},{\"source\":\"Gueulemer\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Gueulemer\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Gueulemer\",\"target\":\"Eponine\",\"value\":1},{\"source\":\"Babet\",\"target\":\"Thenardier\",\"value\":6},{\"source\":\"Babet\",\"target\":\"Gueulemer\",\"value\":6},{\"source\":\"Babet\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Babet\",\"target\":\"Mme.Thenardier\",\"value\":1},{\"source\":\"Babet\",\"target\":\"Javert\",\"value\":2},{\"source\":\"Babet\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Babet\",\"target\":\"Eponine\",\"value\":1},{\"source\":\"Claquesous\",\"target\":\"Thenardier\",\"value\":4},{\"source\":\"Claquesous\",\"target\":\"Babet\",\"value\":4},{\"source\":\"Claquesous\",\"target\":\"Gueulemer\",\"value\":4},{\"source\":\"Claquesous\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Claquesous\",\"target\":\"Mme.Thenardier\",\"value\":1},{\"source\":\"Claquesous\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Claquesous\",\"target\":\"Eponine\",\"value\":1},{\"source\":\"Claquesous\",\"target\":\"Enjolras\",\"value\":1},{\"source\":\"Montparnasse\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Montparnasse\",\"target\":\"Babet\",\"value\":2},{\"source\":\"Montparnasse\",\"target\":\"Gueulemer\",\"value\":2},{\"source\":\"Montparnasse\",\"target\":\"Claquesous\",\"value\":2},{\"source\":\"Montparnasse\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Montparnasse\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Montparnasse\",\"target\":\"Eponine\",\"value\":1},{\"source\":\"Montparnasse\",\"target\":\"Thenardier\",\"value\":1},{\"source\":\"Toussaint\",\"target\":\"Cosette\",\"value\":2},{\"source\":\"Toussaint\",\"target\":\"Javert\",\"value\":1},{\"source\":\"Toussaint\",\"target\":\"Valjean\",\"value\":1},{\"source\":\"Child1\",\"target\":\"Gavroche\",\"value\":2},{\"source\":\"Child2\",\"target\":\"Gavroche\",\"value\":2},{\"source\":\"Child2\",\"target\":\"Child1\",\"value\":3},{\"source\":\"Brujon\",\"target\":\"Babet\",\"value\":3},{\"source\":\"Brujon\",\"target\":\"Gueulemer\",\"value\":3},{\"source\":\"Brujon\",\"target\":\"Thenardier\",\"value\":3},{\"source\":\"Brujon\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Brujon\",\"target\":\"Eponine\",\"value\":1},{\"source\":\"Brujon\",\"target\":\"Claquesous\",\"value\":1},{\"source\":\"Brujon\",\"target\":\"Montparnasse\",\"value\":1},{\"source\":\"Mme.Hucheloup\",\"target\":\"Bossuet\",\"value\":1},{\"source\":\"Mme.Hucheloup\",\"target\":\"Joly\",\"value\":1},{\"source\":\"Mme.Hucheloup\",\"target\":\"Grantaire\",\"value\":1},{\"source\":\"Mme.Hucheloup\",\"target\":\"Bahorel\",\"value\":1},{\"source\":\"Mme.Hucheloup\",\"target\":\"Courfeyrac\",\"value\":1},{\"source\":\"Mme.Hucheloup\",\"target\":\"Gavroche\",\"value\":1},{\"source\":\"Mme.Hucheloup\",\"target\":\"Enjolras\",\"value\":1}]}");


var $15f6d49129e3bec6$exports = {};
$15f6d49129e3bec6$exports = JSON.parse('{"nodes":[{"id":"Structural basis of PROTAC cooperative recognition for selective protein degradation.","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"The influence of rough lipopolysaccharide structure on molecular interactions with mammalian antimicrobial peptides","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"New Synthetic Routes to Triazolo-benzodiazepine Analogues: Expanding the Scope of the Bump-and-Hole Approach for Selective Bromo and Extra-Terminal (BET) Bromodomain Inhibition.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Cyclic and Macrocyclic Peptides as Chemical Tools To Recognise Protein Surfaces and Probe Protein-Protein Interactions.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Discovery of Type II Inhibitors of TGF\u03B2-Activated Kinase 1 (TAK1) and Mitogen-Activated Protein Kinase Kinase Kinase Kinase 2 (MAP4K2)","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"SIK2 regulates CRTCs, HDAC4 and glucose uptake in adipocytes","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Metabotropic Glutamate Receptor 5 Negative Allosteric Modulators: Discovery of 2-Chloro-4-[1-(4-fluorophenyl)-2,5-dimethyl-1H-imidazol-4-ylethynyl]pyridine (Basimglurant, RO4917523), a Promising Novel Medicine for Psychiatric Diseases","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Nrf2 regulates ROS production by mitochondria and NADPH oxidase.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"The clinically approved drugs dasatinib and bosutinib induce anti-inflammatory macrophages by inhibiting the salt-inducible kinases","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"New Monocyclic, Bicyclic, and Tricyclic Ethynylcyanodienones as Activators of the Keap1/Nrf2/ARE Pathway and Inhibitors of Inducible Nitric Oxide Synthase","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Palmitoylation of the Na/Ca exchanger cytoplasmic loop controls its inactivation and internalization during stress signaling","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Molecular Cloning and Functional Characterization of Components of the Capsule Biosynthesis Complex of Neisseria meningitidis Serogroup A TOWARD IN VITRO VACCINE PRODUCTION","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","group":"Cited Works","radius":7,"citing_patents_count":7},{"id":"An unexpected twist to the activation of IKK\u03B2: TAK1 primes IKK\u03B2 for activation by autophosphorylation","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Crystallographic analysis of Neisseria meningitidis PorB extracellular loops potentially implicated in TLR2 recognition","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"The LKB1-salt-inducible kinase pathway functions as a key gluconeogenic suppressor in the liver","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-\u03BAB: potential candidates for chemoprevention.","group":"Cited Works","radius":6,"citing_patents_count":6},{"id":"Carnosic acid stimulates glucose uptake in skeletal muscle cells via a PME-1/PP2A/PKB signalling axis","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Kv1.3 inhibitors have differential effects on glucose uptake and AMPK activity in skeletal muscle cell lines and mouse ex vivo skeletal muscle","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Restoration of CFTR function in patients with cystic fibrosis carrying the F508del-CFTR mutation","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65","group":"Cited Works","radius":4,"citing_patents_count":4},{"id":"Substrate recognition by the cell surface palmitoyl transferase DHHC5.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Dysregulation of ubiquitin homeostasis and \u03B2-catenin signaling promote spinal muscular atrophy","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Structure-Guided Design and Optimization of Small Molecules Targeting the Protein\u2013Protein Interaction between the von Hippel\u2013Lindau (VHL) E3 Ubiquitin Ligase and the Hypoxia Inducible Factor (HIF) Alpha Subunit with in Vitro Nanomolar Affinities","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"The Nrf2 regulatory network provides an interface between redox and intermediary metabolism","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Characterization of WZ4003 and HTH-01-015 as selective inhibitors of the LKB1-tumour-suppressor-activated NUAK kinases","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples","group":"Cited Works","radius":6,"citing_patents_count":6},{"id":"Structure-activity relationship studies of pyrrolone antimalarial agents","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"The Concise Guide to Pharmacology 2013/14.: The Concise Guide to Pharmacology 2013/14: G Protein-Coupled Receptors","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Elevated SGK1 predicts resistance of breast cancer cells to Akt inhibitors","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Metabolism of inflammation limited by AMPK and pseudo-starvation","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Nrf2 impacts cellular bioenergetics by controlling substrate availability for mitochondrial respiration","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"The anti-inflammatory compound BAY 11-7082 is a potent inhibitor of Protein Tyrosine Phosphatases","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Investigation of acyclic uridine amide and 5\u2032-amido nucleoside analogues as potential inhibitors of the Plasmodium falciparum dUTPase","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Discovery and structure-activity relationships of pyrrolone antimalarials","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Comprehensive characterization and optimization of anti-LRRK2 (leucine-rich repeat kinase 2) monoclonal antibodies","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"From On-Target to Off-Target Activity: Identification and Optimisation of Trypanosoma brucei GSK3 Inhibitors and Their Characterisation as Anti-Trypanosoma brucei Drug Discovery Lead Molecules","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"HIF-independent role of prolyl hydroxylases in the cellular response to amino acids","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","group":"Cited Works","radius":11,"citing_patents_count":11},{"id":"A novel shogaol analog suppresses cancer cell invasion and inflammation, and displays cytoprotective effects through modulation of NF-\u03BAB and Nrf2-Keap1 signaling pathways","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"The endosome-lysosome pathway and information generation in the immune system.","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"GSK2578215A; a potent and highly selective 2-arylmethyloxy-5-substitutent-N-arylbenzamide LRRK2 kinase inhibitor.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Structure of the TatC core of the twin-arginine protein transport system","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"The Ancient Drug Salicylate Directly Activates AMP-Activated Protein Kinase","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Application of a novel highly sensitive activity-based probe for detection of cathepsin G","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Analysis of the role of Nrf2 in the expression of liver proteins in mice using two-dimensional gel-based proteomics","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Synthesis, Chemical Reactivity as Michael Acceptors, and Biological Potency of Monocyclic Cyanoenones, Novel and Highly Potent Anti-inflammatory and Cytoprotective Agents(1)","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors","group":"Cited Works","radius":5,"citing_patents_count":5},{"id":"Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Chemical Proteomic Analysis Reveals the Drugability of the Kinome of Trypanosoma brucei","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Avirulence Protein 3a (AVR3a) from the Potato Pathogen Phytophthora infestans Forms Homodimers through Its Predicted Translocation Region and Does Not Specifically Bind Phospholipids","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"NEDD8 overexpression results in neddylation of ubiquitin substrates by the ubiquitin pathway.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Kinome-wide Selectivity Profiling of ATP-competitive Mammalian Target of Rapamycin (mTOR) Inhibitors and Characterization of Their Binding Kinetics","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"The ubiquitin E1 enzyme Ube1 mediates NEDD8 activation under diverse stress conditions","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Acinetobacter baumannii FolD ligand complexes \u2013 potent inhibitors of folate metabolism and a re\u2010evaluation of the structure of LY374571","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Aurora kinase inhibitors: Progress towards the clinic","group":"Cited Works","radius":12,"citing_patents_count":12},{"id":"The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Synergy of Peptide and Sugar in O-GlcNAcase Substrate Recognition","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Discovery of potent and selective covalent inhibitors of JNK","group":"Cited Works","radius":6,"citing_patents_count":6},{"id":"Phosphorylation of FOXO3a on Ser-7 by p38 Promotes Its Nuclear Localization in Response to Doxorubicin","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"AMPK: a nutrient and energy sensor that maintains energy homeostasis","group":"Cited Works","radius":6,"citing_patents_count":6},{"id":"Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKK\u03B5 kinases.","group":"Cited Works","radius":4,"citing_patents_count":4},{"id":"Peptide inhibitors of the Keap1-Nrf2 protein-protein interaction","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Small molecules that bind the Mdm2 RING stabilize and activate p53","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","group":"Cited Works","radius":29,"citing_patents_count":29},{"id":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","group":"Cited Works","radius":11,"citing_patents_count":11},{"id":"Changes in the ratio of free NEDD8 to ubiquitin triggers NEDDylation by ubiquitin enzymes","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.","group":"Cited Works","radius":4,"citing_patents_count":4},{"id":"A multifunctional protease inhibitor to regulate endolysosomal function.","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Design, Synthesis, and Structure\u2212Activity Relationship Exploration of 1-Substituted 4-Aroyl-3-hydroxy-5-phenyl-1H-pyrrol-2(5H)-one Analogues as Inhibitors of the Annexin A2\u2212S100A10 Protein Interaction","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"4-benzimidazolyl-3-phenylbutanoic acids as novel PIF-pocket-targeting allosteric inhibitors of protein kinase PKC\u03B6.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors","group":"Cited Works","radius":4,"citing_patents_count":4},{"id":"Design, Synthesis and Biological Evaluation of Novel Inhibitors of Trypanosoma brucei Pteridine Reductase 1","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"The inhibitory effect of phospholemman on the sodium pump requires its palmitoylation.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"SCF/\u03B2-TrCP promotes glycogen synthase kinase 3-dependent degradation of the Nrf2 transcription factor in a keap1-independent manner","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Immunosuppressive but Non-LasR-Inducing Analogues of the Pseudomonas aeruginosa Quorum-Sensing Molecule N-(3-Oxododecanoyl)-L-homoserine Lactone","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Absolute SILAC-Compatible Expression Strain Allows Sumo-2 Copy Number Determination in Clinical Samples","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Collateral sensitivity of multidrug-resistant cells to the orphan drug tiopronin.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","group":"Cited Works","radius":11,"citing_patents_count":11},{"id":"ATP site-directed inhibitors of protein kinase CK2: an update.","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Polyubiquitin binding to optineurin is required for optimal activation of TANK-binding kinase 1 and production of interferon \u03B2.","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.","group":"Cited Works","radius":4,"citing_patents_count":4},{"id":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","group":"Cited Works","radius":7,"citing_patents_count":7},{"id":"Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Analgesic omega-Conotoxins CVIE and CVIF Selectively and Voltage-Dependently Block Recombinant and Native N-Type Calcium Channels (vol 77, pg 139, 2010)","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"NF-\u03BAB controls energy homeostasis and metabolic adaptation by upregulating mitochondrial respiration","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"Development of 18F-fluorinatable dendrons and their application to cancer cell targeting","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"The specificities of small molecule inhibitors of the TGF\xdf and BMP pathways","group":"Cited Works","radius":3,"citing_patents_count":3},{"id":"Catalysis by the nucleolytic ribozymes","group":"Cited Works","radius":5,"citing_patents_count":5},{"id":"Characterization of GSK2334470, a novel and highly specific inhibitor of PDK1","group":"Cited Works","radius":2,"citing_patents_count":2},{"id":"N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases","group":"Cited Works","radius":4,"citing_patents_count":4},{"id":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","group":"Cited Works","radius":7,"citing_patents_count":7},{"id":"Optimisation of the Anti-Trypanosoma brucei Activity of the Opioid Agonist U50488","group":"Cited Works","radius":1,"citing_patents_count":1},{"id":"109-294-662-661-65X","group":"Citing Patents"},{"id":"074-937-457-594-345","group":"Citing Patents"},{"id":"081-355-367-506-27X","group":"Citing Patents"},{"id":"048-634-530-447-798","group":"Citing Patents"},{"id":"137-231-469-269-151","group":"Citing Patents"},{"id":"031-072-815-607-16X","group":"Citing Patents"},{"id":"105-312-070-982-098","group":"Citing Patents"},{"id":"018-515-082-074-296","group":"Citing Patents"},{"id":"027-228-373-793-594","group":"Citing Patents"},{"id":"016-712-604-622-721","group":"Citing Patents"},{"id":"086-316-087-480-933","group":"Citing Patents"},{"id":"118-309-833-112-117","group":"Citing Patents"},{"id":"134-672-819-080-83X","group":"Citing Patents"},{"id":"036-789-224-520-054","group":"Citing Patents"},{"id":"106-594-488-484-12X","group":"Citing Patents"},{"id":"125-726-727-125-409","group":"Citing Patents"},{"id":"161-487-188-181-03X","group":"Citing Patents"},{"id":"076-538-237-089-675","group":"Citing Patents"},{"id":"051-324-518-696-462","group":"Citing Patents"},{"id":"198-017-973-913-570","group":"Citing Patents"},{"id":"156-653-831-632-101","group":"Citing Patents"},{"id":"178-739-712-688-618","group":"Citing Patents"},{"id":"131-486-498-702-07X","group":"Citing Patents"},{"id":"010-031-167-075-106","group":"Citing Patents"},{"id":"119-453-428-180-987","group":"Citing Patents"},{"id":"153-595-914-216-97X","group":"Citing Patents"},{"id":"148-353-591-913-750","group":"Citing Patents"},{"id":"019-827-938-996-490","group":"Citing Patents"},{"id":"184-646-935-269-773","group":"Citing Patents"},{"id":"186-230-275-872-748","group":"Citing Patents"},{"id":"165-291-395-706-725","group":"Citing Patents"},{"id":"047-113-007-956-15X","group":"Citing Patents"},{"id":"089-019-916-582-397","group":"Citing Patents"},{"id":"136-000-598-663-919","group":"Citing Patents"},{"id":"051-072-189-723-758","group":"Citing Patents"},{"id":"040-766-915-457-886","group":"Citing Patents"},{"id":"141-482-415-400-338","group":"Citing Patents"},{"id":"149-129-599-518-595","group":"Citing Patents"},{"id":"156-286-485-464-499","group":"Citing Patents"},{"id":"001-353-214-346-040","group":"Citing Patents"},{"id":"118-479-143-842-720","group":"Citing Patents"},{"id":"007-641-959-106-118","group":"Citing Patents"},{"id":"189-040-066-278-226","group":"Citing Patents"},{"id":"026-244-336-682-442","group":"Citing Patents"},{"id":"168-286-254-597-740","group":"Citing Patents"},{"id":"109-916-358-959-05X","group":"Citing Patents"},{"id":"002-458-268-309-533","group":"Citing Patents"},{"id":"038-310-729-099-192","group":"Citing Patents"},{"id":"179-033-965-606-598","group":"Citing Patents"},{"id":"113-229-447-433-64X","group":"Citing Patents"},{"id":"077-771-399-719-227","group":"Citing Patents"},{"id":"183-966-651-664-305","group":"Citing Patents"},{"id":"013-467-292-050-692","group":"Citing Patents"},{"id":"079-314-054-163-947","group":"Citing Patents"},{"id":"110-082-309-221-187","group":"Citing Patents"},{"id":"128-382-566-327-896","group":"Citing Patents"},{"id":"143-543-676-408-839","group":"Citing Patents"},{"id":"005-743-260-244-802","group":"Citing Patents"},{"id":"026-638-223-054-804","group":"Citing Patents"},{"id":"048-208-660-423-215","group":"Citing Patents"},{"id":"159-658-602-048-982","group":"Citing Patents"},{"id":"077-811-145-153-079","group":"Citing Patents"},{"id":"170-781-236-728-970","group":"Citing Patents"},{"id":"144-284-594-583-951","group":"Citing Patents"},{"id":"139-409-891-293-77X","group":"Citing Patents"},{"id":"081-017-751-048-013","group":"Citing Patents"},{"id":"114-963-910-586-828","group":"Citing Patents"},{"id":"162-513-842-046-362","group":"Citing Patents"},{"id":"188-803-921-043-695","group":"Citing Patents"},{"id":"191-147-881-232-285","group":"Citing Patents"},{"id":"081-817-015-173-962","group":"Citing Patents"},{"id":"106-530-060-683-82X","group":"Citing Patents"},{"id":"133-935-409-400-672","group":"Citing Patents"},{"id":"046-588-899-387-353","group":"Citing Patents"},{"id":"049-222-171-973-678","group":"Citing Patents"},{"id":"074-598-665-914-143","group":"Citing Patents"},{"id":"190-195-697-065-907","group":"Citing Patents"},{"id":"031-461-589-086-771","group":"Citing Patents"},{"id":"167-851-091-520-257","group":"Citing Patents"},{"id":"151-760-923-304-502","group":"Citing Patents"},{"id":"097-019-537-894-104","group":"Citing Patents"},{"id":"170-696-774-214-700","group":"Citing Patents"},{"id":"084-807-525-209-072","group":"Citing Patents"},{"id":"044-648-704-787-12X","group":"Citing Patents"},{"id":"150-822-190-827-131","group":"Citing Patents"},{"id":"051-919-508-851-10X","group":"Citing Patents"},{"id":"036-251-116-198-69X","group":"Citing Patents"},{"id":"149-946-446-737-586","group":"Citing Patents"},{"id":"075-397-286-033-085","group":"Citing Patents"},{"id":"028-992-308-265-357","group":"Citing Patents"},{"id":"044-207-676-689-405","group":"Citing Patents"},{"id":"030-350-713-791-200","group":"Citing Patents"},{"id":"093-997-239-092-949","group":"Citing Patents"},{"id":"046-345-437-716-689","group":"Citing Patents"},{"id":"146-411-731-640-871","group":"Citing Patents"},{"id":"000-266-572-036-366","group":"Citing Patents"},{"id":"186-389-876-954-313","group":"Citing Patents"},{"id":"168-483-508-794-377","group":"Citing Patents"},{"id":"029-748-240-628-036","group":"Citing Patents"},{"id":"184-507-509-452-559","group":"Citing Patents"},{"id":"069-961-069-943-549","group":"Citing Patents"},{"id":"017-777-392-752-199","group":"Citing Patents"},{"id":"000-150-893-948-804","group":"Citing Patents"},{"id":"027-437-502-794-894","group":"Citing Patents"},{"id":"074-789-039-135-70X","group":"Citing Patents"},{"id":"063-617-165-524-327","group":"Citing Patents"},{"id":"019-872-586-012-269","group":"Citing Patents"},{"id":"103-648-347-913-447","group":"Citing Patents"},{"id":"007-245-406-573-328","group":"Citing Patents"},{"id":"008-337-248-044-723","group":"Citing Patents"},{"id":"197-071-041-313-103","group":"Citing Patents"},{"id":"098-538-513-984-747","group":"Citing Patents"},{"id":"019-125-805-246-964","group":"Citing Patents"},{"id":"172-064-016-145-117","group":"Citing Patents"},{"id":"007-417-942-335-284","group":"Citing Patents"},{"id":"005-947-025-410-764","group":"Citing Patents"},{"id":"116-404-026-640-450","group":"Citing Patents"},{"id":"090-437-295-781-023","group":"Citing Patents"},{"id":"197-158-559-918-854","group":"Citing Patents"},{"id":"076-225-263-850-117","group":"Citing Patents"},{"id":"049-199-509-181-561","group":"Citing Patents"},{"id":"179-045-041-176-506","group":"Citing Patents"},{"id":"004-301-778-674-378","group":"Citing Patents"},{"id":"111-313-231-732-367","group":"Citing Patents"},{"id":"092-197-031-561-353","group":"Citing Patents"},{"id":"192-019-786-423-841","group":"Citing Patents"},{"id":"076-608-180-638-59X","group":"Citing Patents"},{"id":"175-263-797-963-040","group":"Citing Patents"},{"id":"141-694-167-791-759","group":"Citing Patents"},{"id":"081-203-444-563-604","group":"Citing Patents"},{"id":"125-348-249-762-351","group":"Citing Patents"},{"id":"125-850-986-196-787","group":"Citing Patents"},{"id":"119-397-162-706-860","group":"Citing Patents"},{"id":"133-023-408-974-285","group":"Citing Patents"},{"id":"039-847-299-166-952","group":"Citing Patents"},{"id":"076-641-402-312-988","group":"Citing Patents"},{"id":"102-485-198-725-150","group":"Citing Patents"},{"id":"168-829-456-947-639","group":"Citing Patents"},{"id":"098-813-369-162-741","group":"Citing Patents"},{"id":"023-180-369-416-862","group":"Citing Patents"},{"id":"189-473-046-734-005","group":"Citing Patents"},{"id":"019-633-684-883-828","group":"Citing Patents"},{"id":"174-501-376-407-235","group":"Citing Patents"},{"id":"129-062-448-949-030","group":"Citing Patents"},{"id":"162-916-741-322-002","group":"Citing Patents"},{"id":"080-026-305-809-343","group":"Citing Patents"},{"id":"016-698-167-713-829","group":"Citing Patents"},{"id":"091-325-080-234-401","group":"Citing Patents"},{"id":"032-206-614-235-635","group":"Citing Patents"},{"id":"143-271-017-351-983","group":"Citing Patents"},{"id":"169-312-245-869-778","group":"Citing Patents"},{"id":"089-818-979-077-305","group":"Citing Patents"},{"id":"187-517-157-601-239","group":"Citing Patents"},{"id":"111-583-988-147-450","group":"Citing Patents"},{"id":"058-026-435-099-506","group":"Citing Patents"},{"id":"153-651-762-444-327","group":"Citing Patents"},{"id":"159-766-711-047-610","group":"Citing Patents"},{"id":"058-933-099-316-100","group":"Citing Patents"},{"id":"023-452-662-674-373","group":"Citing Patents"},{"id":"047-432-030-246-04X","group":"Citing Patents"},{"id":"139-008-712-602-518","group":"Citing Patents"},{"id":"137-720-748-139-162","group":"Citing Patents"},{"id":"192-136-893-476-749","group":"Citing Patents"},{"id":"172-890-893-515-719","group":"Citing Patents"},{"id":"104-472-615-006-481","group":"Citing Patents"},{"id":"097-374-332-908-898","group":"Citing Patents"},{"id":"034-416-075-094-770","group":"Citing Patents"},{"id":"127-642-274-375-054","group":"Citing Patents"},{"id":"036-708-909-192-156","group":"Citing Patents"},{"id":"193-863-590-855-263","group":"Citing Patents"},{"id":"150-028-859-997-047","group":"Citing Patents"},{"id":"132-394-716-226-832","group":"Citing Patents"},{"id":"131-238-819-455-784","group":"Citing Patents"},{"id":"155-402-461-387-483","group":"Citing Patents"},{"id":"040-389-070-176-191","group":"Citing Patents"},{"id":"076-478-479-475-120","group":"Citing Patents"},{"id":"034-190-802-321-708","group":"Citing Patents"},{"id":"130-316-719-983-242","group":"Citing Patents"},{"id":"036-668-261-470-040","group":"Citing Patents"},{"id":"183-767-289-461-131","group":"Citing Patents"},{"id":"107-556-164-321-147","group":"Citing Patents"},{"id":"066-190-726-252-149","group":"Citing Patents"},{"id":"140-900-012-438-14X","group":"Citing Patents"},{"id":"058-438-690-312-096","group":"Citing Patents"},{"id":"004-889-112-130-518","group":"Citing Patents"},{"id":"193-040-307-473-220","group":"Citing Patents"},{"id":"188-718-220-131-362","group":"Citing Patents"},{"id":"087-577-350-425-176","group":"Citing Patents"},{"id":"191-670-060-004-126","group":"Citing Patents"},{"id":"041-699-843-843-567","group":"Citing Patents"},{"id":"180-366-233-781-99X","group":"Citing Patents"},{"id":"122-739-962-072-793","group":"Citing Patents"},{"id":"109-274-898-147-341","group":"Citing Patents"},{"id":"124-179-501-005-870","group":"Citing Patents"},{"id":"008-694-981-426-172","group":"Citing Patents"},{"id":"109-611-546-954-080","group":"Citing Patents"},{"id":"004-378-254-734-355","group":"Citing Patents"},{"id":"133-997-520-845-569","group":"Citing Patents"},{"id":"115-381-943-359-61X","group":"Citing Patents"},{"id":"022-078-711-389-998","group":"Citing Patents"},{"id":"132-854-391-972-865","group":"Citing Patents"},{"id":"171-143-110-884-468","group":"Citing Patents"},{"id":"003-946-199-636-328","group":"Citing Patents"},{"id":"009-649-401-227-606","group":"Citing Patents"},{"id":"170-042-571-881-121","group":"Citing Patents"},{"id":"033-301-273-471-462","group":"Citing Patents"},{"id":"040-826-560-477-838","group":"Citing Patents"},{"id":"135-293-472-746-415","group":"Citing Patents"},{"id":"153-999-081-812-523","group":"Citing Patents"},{"id":"000-498-778-953-787","group":"Citing Patents"},{"id":"085-065-777-135-758","group":"Citing Patents"},{"id":"152-366-692-522-975","group":"Citing Patents"},{"id":"167-869-142-610-582","group":"Citing Patents"},{"id":"191-676-336-200-724","group":"Citing Patents"},{"id":"056-387-403-639-935","group":"Citing Patents"},{"id":"066-841-401-628-941","group":"Citing Patents"},{"id":"069-503-782-573-055","group":"Citing Patents"},{"id":"028-137-796-142-577","group":"Citing Patents"},{"id":"197-678-301-596-236","group":"Citing Patents"},{"id":"147-466-934-435-143","group":"Citing Patents"},{"id":"114-647-123-099-321","group":"Citing Patents"},{"id":"058-829-130-504-901","group":"Citing Patents"},{"id":"169-953-034-717-264","group":"Citing Patents"},{"id":"028-012-588-449-727","group":"Citing Patents"},{"id":"038-839-140-589-623","group":"Citing Patents"},{"id":"194-924-906-201-593","group":"Citing Patents"},{"id":"195-611-964-620-410","group":"Citing Patents"},{"id":"025-014-524-538-421","group":"Citing Patents"},{"id":"120-667-268-642-909","group":"Citing Patents"},{"id":"163-117-320-460-138","group":"Citing Patents"},{"id":"191-290-593-697-506","group":"Citing Patents"},{"id":"118-339-847-530-982","group":"Citing Patents"},{"id":"073-318-370-112-877","group":"Citing Patents"},{"id":"113-828-920-381-078","group":"Citing Patents"},{"id":"048-983-957-537-421","group":"Citing Patents"},{"id":"073-531-962-083-670","group":"Citing Patents"}],"links":[{"source":"Structural basis of PROTAC cooperative recognition for selective protein degradation.","target":"109-294-662-661-65X","value":2},{"source":"Structural basis of PROTAC cooperative recognition for selective protein degradation.","target":"074-937-457-594-345","value":2},{"source":"The influence of rough lipopolysaccharide structure on molecular interactions with mammalian antimicrobial peptides","target":"081-355-367-506-27X","value":2},{"source":"New Synthetic Routes to Triazolo-benzodiazepine Analogues: Expanding the Scope of the Bump-and-Hole Approach for Selective Bromo and Extra-Terminal (BET) Bromodomain Inhibition.","target":"048-634-530-447-798","value":2},{"source":"Cyclic and Macrocyclic Peptides as Chemical Tools To Recognise Protein Surfaces and Probe Protein-Protein Interactions.","target":"137-231-469-269-151","value":2},{"source":"8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.","target":"031-072-815-607-16X","value":2},{"source":"8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.","target":"105-312-070-982-098","value":2},{"source":"8-Substituted Pyrido[3,4-d]pyrimidin-4(3H)-one Derivatives As Potent, Cell Permeable, KDM4 (JMJD2) and KDM5 (JARID1) Histone Lysine Demethylase Inhibitors.","target":"018-515-082-074-296","value":2},{"source":"Discovery of Type II Inhibitors of TGF\u03B2-Activated Kinase 1 (TAK1) and Mitogen-Activated Protein Kinase Kinase Kinase Kinase 2 (MAP4K2)","target":"027-228-373-793-594","value":2},{"source":"SIK2 regulates CRTCs, HDAC4 and glucose uptake in adipocytes","target":"016-712-604-622-721","value":2},{"source":"Metabotropic Glutamate Receptor 5 Negative Allosteric Modulators: Discovery of 2-Chloro-4-[1-(4-fluorophenyl)-2,5-dimethyl-1H-imidazol-4-ylethynyl]pyridine (Basimglurant, RO4917523), a Promising Novel Medicine for Psychiatric Diseases","target":"086-316-087-480-933","value":2},{"source":"Nrf2 regulates ROS production by mitochondria and NADPH oxidase.","target":"118-309-833-112-117","value":2},{"source":"The clinically approved drugs dasatinib and bosutinib induce anti-inflammatory macrophages by inhibiting the salt-inducible kinases","target":"134-672-819-080-83X","value":2},{"source":"New Monocyclic, Bicyclic, and Tricyclic Ethynylcyanodienones as Activators of the Keap1/Nrf2/ARE Pathway and Inhibitors of Inducible Nitric Oxide Synthase","target":"036-789-224-520-054","value":2},{"source":"Palmitoylation of the Na/Ca exchanger cytoplasmic loop controls its inactivation and internalization during stress signaling","target":"106-594-488-484-12X","value":2},{"source":"Molecular Cloning and Functional Characterization of Components of the Capsule Biosynthesis Complex of Neisseria meningitidis Serogroup A TOWARD IN VITRO VACCINE PRODUCTION","target":"125-726-727-125-409","value":2},{"source":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","target":"161-487-188-181-03X","value":2},{"source":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","target":"076-538-237-089-675","value":2},{"source":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","target":"051-324-518-696-462","value":2},{"source":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","target":"198-017-973-913-570","value":2},{"source":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","target":"156-653-831-632-101","value":2},{"source":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","target":"178-739-712-688-618","value":2},{"source":"A bump-and-hole approach to engineer controlled selectivity of BET bromodomain chemical probes","target":"048-634-530-447-798","value":2},{"source":"An unexpected twist to the activation of IKK\u03B2: TAK1 primes IKK\u03B2 for activation by autophosphorylation","target":"131-486-498-702-07X","value":2},{"source":"An unexpected twist to the activation of IKK\u03B2: TAK1 primes IKK\u03B2 for activation by autophosphorylation","target":"010-031-167-075-106","value":2},{"source":"Crystallographic analysis of Neisseria meningitidis PorB extracellular loops potentially implicated in TLR2 recognition","target":"119-453-428-180-987","value":2},{"source":"The LKB1-salt-inducible kinase pathway functions as a key gluconeogenic suppressor in the liver","target":"016-712-604-622-721","value":2},{"source":"Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase","target":"153-595-914-216-97X","value":2},{"source":"Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase","target":"148-353-591-913-750","value":2},{"source":"Characterization of VPS34-IN1, a selective inhibitor of Vps34, reveals that the phosphatidylinositol 3-phosphate-binding SGK3 protein kinase is a downstream target of class III phosphoinositide 3-kinase","target":"019-827-938-996-490","value":2},{"source":"3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-\u03BAB: potential candidates for chemoprevention.","target":"184-646-935-269-773","value":2},{"source":"3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-\u03BAB: potential candidates for chemoprevention.","target":"186-230-275-872-748","value":2},{"source":"3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-\u03BAB: potential candidates for chemoprevention.","target":"165-291-395-706-725","value":2},{"source":"3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-\u03BAB: potential candidates for chemoprevention.","target":"047-113-007-956-15X","value":2},{"source":"3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-\u03BAB: potential candidates for chemoprevention.","target":"089-019-916-582-397","value":2},{"source":"3-(2-oxoethylidene)indolin-2-one derivatives activate Nrf2 and inhibit NF-\u03BAB: potential candidates for chemoprevention.","target":"136-000-598-663-919","value":2},{"source":"Carnosic acid stimulates glucose uptake in skeletal muscle cells via a PME-1/PP2A/PKB signalling axis","target":"051-072-189-723-758","value":2},{"source":"Kv1.3 inhibitors have differential effects on glucose uptake and AMPK activity in skeletal muscle cell lines and mouse ex vivo skeletal muscle","target":"040-766-915-457-886","value":2},{"source":"Kv1.3 inhibitors have differential effects on glucose uptake and AMPK activity in skeletal muscle cell lines and mouse ex vivo skeletal muscle","target":"141-482-415-400-338","value":2},{"source":"Restoration of CFTR function in patients with cystic fibrosis carrying the F508del-CFTR mutation","target":"149-129-599-518-595","value":2},{"source":"Restoration of CFTR function in patients with cystic fibrosis carrying the F508del-CFTR mutation","target":"156-286-485-464-499","value":2},{"source":"Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65","target":"001-353-214-346-040","value":2},{"source":"Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65","target":"118-479-143-842-720","value":2},{"source":"Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65","target":"007-641-959-106-118","value":2},{"source":"Parkin is activated by PINK1-dependent phosphorylation of ubiquitin at Ser65","target":"189-040-066-278-226","value":2},{"source":"Substrate recognition by the cell surface palmitoyl transferase DHHC5.","target":"106-594-488-484-12X","value":2},{"source":"Dysregulation of ubiquitin homeostasis and \u03B2-catenin signaling promote spinal muscular atrophy","target":"026-244-336-682-442","value":2},{"source":"Structure-Guided Design and Optimization of Small Molecules Targeting the Protein\u2013Protein Interaction between the von Hippel\u2013Lindau (VHL) E3 Ubiquitin Ligase and the Hypoxia Inducible Factor (HIF) Alpha Subunit with in Vitro Nanomolar Affinities","target":"074-937-457-594-345","value":2},{"source":"Structure-Guided Design and Optimization of Small Molecules Targeting the Protein\u2013Protein Interaction between the von Hippel\u2013Lindau (VHL) E3 Ubiquitin Ligase and the Hypoxia Inducible Factor (HIF) Alpha Subunit with in Vitro Nanomolar Affinities","target":"168-286-254-597-740","value":2},{"source":"The Nrf2 regulatory network provides an interface between redox and intermediary metabolism","target":"109-916-358-959-05X","value":2},{"source":"Characterization of WZ4003 and HTH-01-015 as selective inhibitors of the LKB1-tumour-suppressor-activated NUAK kinases","target":"002-458-268-309-533","value":2},{"source":"Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples","target":"038-310-729-099-192","value":2},{"source":"Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples","target":"179-033-965-606-598","value":2},{"source":"Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples","target":"113-229-447-433-64X","value":2},{"source":"Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples","target":"077-771-399-719-227","value":2},{"source":"Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples","target":"183-966-651-664-305","value":2},{"source":"Synthesis of vitamin D3 analogues with A-ring modifications to directly measure vitamin D levels in biological samples","target":"013-467-292-050-692","value":2},{"source":"Structure-activity relationship studies of pyrrolone antimalarial agents","target":"079-314-054-163-947","value":2},{"source":"Structure-activity relationship studies of pyrrolone antimalarial agents","target":"110-082-309-221-187","value":2},{"source":"The Concise Guide to Pharmacology 2013/14.: The Concise Guide to Pharmacology 2013/14: G Protein-Coupled Receptors","target":"128-382-566-327-896","value":2},{"source":"The Concise Guide to Pharmacology 2013/14.: The Concise Guide to Pharmacology 2013/14: G Protein-Coupled Receptors","target":"143-543-676-408-839","value":2},{"source":"Elevated SGK1 predicts resistance of breast cancer cells to Akt inhibitors","target":"005-743-260-244-802","value":2},{"source":"Metabolism of inflammation limited by AMPK and pseudo-starvation","target":"026-638-223-054-804","value":2},{"source":"Nrf2 impacts cellular bioenergetics by controlling substrate availability for mitochondrial respiration","target":"048-208-660-423-215","value":2},{"source":"The anti-inflammatory compound BAY 11-7082 is a potent inhibitor of Protein Tyrosine Phosphatases","target":"159-658-602-048-982","value":2},{"source":"BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm","target":"077-811-145-153-079","value":2},{"source":"BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm","target":"170-781-236-728-970","value":2},{"source":"BslA is a self-assembling bacterial hydrophobin that coats the Bacillus subtilis biofilm","target":"144-284-594-583-951","value":2},{"source":"Investigation of acyclic uridine amide and 5\u2032-amido nucleoside analogues as potential inhibitors of the Plasmodium falciparum dUTPase","target":"139-409-891-293-77X","value":2},{"source":"Discovery and structure-activity relationships of pyrrolone antimalarials","target":"110-082-309-221-187","value":2},{"source":"De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments","target":"081-017-751-048-013","value":2},{"source":"De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments","target":"114-963-910-586-828","value":2},{"source":"De Novo Design of Protein Kinase Inhibitors by in Silico Identification of Hinge Region-Binding Fragments","target":"162-513-842-046-362","value":2},{"source":"Comprehensive characterization and optimization of anti-LRRK2 (leucine-rich repeat kinase 2) monoclonal antibodies","target":"188-803-921-043-695","value":2},{"source":"From On-Target to Off-Target Activity: Identification and Optimisation of Trypanosoma brucei GSK3 Inhibitors and Their Characterisation as Anti-Trypanosoma brucei Drug Discovery Lead Molecules","target":"191-147-881-232-285","value":2},{"source":"From On-Target to Off-Target Activity: Identification and Optimisation of Trypanosoma brucei GSK3 Inhibitors and Their Characterisation as Anti-Trypanosoma brucei Drug Discovery Lead Molecules","target":"081-817-015-173-962","value":2},{"source":"HIF-independent role of prolyl hydroxylases in the cellular response to amino acids","target":"106-530-060-683-82X","value":2},{"source":"HIF-independent role of prolyl hydroxylases in the cellular response to amino acids","target":"133-935-409-400-672","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"046-588-899-387-353","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"051-324-518-696-462","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"161-487-188-181-03X","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"156-653-831-632-101","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"198-017-973-913-570","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"076-538-237-089-675","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"198-017-973-913-570","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"076-538-237-089-675","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"051-324-518-696-462","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"161-487-188-181-03X","value":2},{"source":"Structural determinants for ERK5 (MAPK7) and leucine rich repeat kinase 2 activities of benzo[e]pyrimido-[5,4-b]diazepine-6(11H)-ones","target":"156-653-831-632-101","value":2},{"source":"A novel shogaol analog suppresses cancer cell invasion and inflammation, and displays cytoprotective effects through modulation of NF-\u03BAB and Nrf2-Keap1 signaling pathways","target":"049-222-171-973-678","value":2},{"source":"A novel shogaol analog suppresses cancer cell invasion and inflammation, and displays cytoprotective effects through modulation of NF-\u03BAB and Nrf2-Keap1 signaling pathways","target":"074-598-665-914-143","value":2},{"source":"X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor","target":"161-487-188-181-03X","value":2},{"source":"X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor","target":"156-653-831-632-101","value":2},{"source":"X-ray Crystal Structure of ERK5 (MAPK7) in Complex with a Specific Inhibitor","target":"051-324-518-696-462","value":2},{"source":"The endosome-lysosome pathway and information generation in the immune system.","target":"190-195-697-065-907","value":2},{"source":"The endosome-lysosome pathway and information generation in the immune system.","target":"031-461-589-086-771","value":2},{"source":"GSK2578215A; a potent and highly selective 2-arylmethyloxy-5-substitutent-N-arylbenzamide LRRK2 kinase inhibitor.","target":"167-851-091-520-257","value":2},{"source":"Structure of the TatC core of the twin-arginine protein transport system","target":"151-760-923-304-502","value":2},{"source":"The Ancient Drug Salicylate Directly Activates AMP-Activated Protein Kinase","target":"097-019-537-894-104","value":2},{"source":"The Ancient Drug Salicylate Directly Activates AMP-Activated Protein Kinase","target":"170-696-774-214-700","value":2},{"source":"Application of a novel highly sensitive activity-based probe for detection of cathepsin G","target":"084-807-525-209-072","value":2},{"source":"Analysis of the role of Nrf2 in the expression of liver proteins in mice using two-dimensional gel-based proteomics","target":"044-648-704-787-12X","value":2},{"source":"PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65","target":"001-353-214-346-040","value":2},{"source":"PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65","target":"150-822-190-827-131","value":2},{"source":"PINK1 is activated by mitochondrial membrane potential depolarization and stimulates Parkin E3 ligase activity by phosphorylating Serine 65","target":"051-919-508-851-10X","value":2},{"source":"Synthesis, Chemical Reactivity as Michael Acceptors, and Biological Potency of Monocyclic Cyanoenones, Novel and Highly Potent Anti-inflammatory and Cytoprotective Agents(1)","target":"036-789-224-520-054","value":2},{"source":"Synthesis, Chemical Reactivity as Michael Acceptors, and Biological Potency of Monocyclic Cyanoenones, Novel and Highly Potent Anti-inflammatory and Cytoprotective Agents(1)","target":"036-251-116-198-69X","value":2},{"source":"Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors","target":"149-946-446-737-586","value":2},{"source":"Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors","target":"075-397-286-033-085","value":2},{"source":"Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors","target":"028-992-308-265-357","value":2},{"source":"Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors","target":"044-207-676-689-405","value":2},{"source":"Design, Synthesis and Biological Evaluation of Trypanosoma brucei Trypanothione Synthetase Inhibitors","target":"030-350-713-791-200","value":2},{"source":"Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.","target":"093-997-239-092-949","value":2},{"source":"Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.","target":"046-345-437-716-689","value":2},{"source":"Mitogen-activated protein kinase-activated protein kinase 2 (MAPKAP-K2) as an antiinflammatory target: discovery and in vivo activity of selective pyrazolo[1,5-a]pyrimidine inhibitors using a focused library and structure-based optimization approach.","target":"146-411-731-640-871","value":2},{"source":"Chemical Proteomic Analysis Reveals the Drugability of the Kinome of Trypanosoma brucei","target":"000-266-572-036-366","value":2},{"source":"Avirulence Protein 3a (AVR3a) from the Potato Pathogen Phytophthora infestans Forms Homodimers through Its Predicted Translocation Region and Does Not Specifically Bind Phospholipids","target":"186-389-876-954-313","value":2},{"source":"NEDD8 overexpression results in neddylation of ubiquitin substrates by the ubiquitin pathway.","target":"168-483-508-794-377","value":2},{"source":"Kinome-wide Selectivity Profiling of ATP-competitive Mammalian Target of Rapamycin (mTOR) Inhibitors and Characterization of Their Binding Kinetics","target":"029-748-240-628-036","value":2},{"source":"The ubiquitin E1 enzyme Ube1 mediates NEDD8 activation under diverse stress conditions","target":"184-507-509-452-559","value":2},{"source":"Acinetobacter baumannii FolD ligand complexes \u2013 potent inhibitors of folate metabolism and a re\u2010evaluation of the structure of LY374571","target":"069-961-069-943-549","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"017-777-392-752-199","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"000-150-893-948-804","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"027-437-502-794-894","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"074-789-039-135-70X","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"063-617-165-524-327","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"019-872-586-012-269","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"103-648-347-913-447","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"007-245-406-573-328","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"027-437-502-794-894","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"008-337-248-044-723","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"197-071-041-313-103","value":2},{"source":"Aurora kinase inhibitors: Progress towards the clinic","target":"098-538-513-984-747","value":2},{"source":"The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes","target":"019-125-805-246-964","value":2},{"source":"The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes","target":"172-064-016-145-117","value":2},{"source":"The AMPK-related kinase SIK2 is regulated by cAMP via phosphorylation at Ser(358) in adipocytes","target":"007-417-942-335-284","value":2},{"source":"Synergy of Peptide and Sugar in O-GlcNAcase Substrate Recognition","target":"005-947-025-410-764","value":2},{"source":"Synergy of Peptide and Sugar in O-GlcNAcase Substrate Recognition","target":"116-404-026-640-450","value":2},{"source":"Discovery of potent and selective covalent inhibitors of JNK","target":"090-437-295-781-023","value":2},{"source":"Discovery of potent and selective covalent inhibitors of JNK","target":"197-158-559-918-854","value":2},{"source":"Discovery of potent and selective covalent inhibitors of JNK","target":"076-225-263-850-117","value":2},{"source":"Discovery of potent and selective covalent inhibitors of JNK","target":"049-199-509-181-561","value":2},{"source":"Discovery of potent and selective covalent inhibitors of JNK","target":"179-045-041-176-506","value":2},{"source":"Discovery of potent and selective covalent inhibitors of JNK","target":"004-301-778-674-378","value":2},{"source":"Phosphorylation of FOXO3a on Ser-7 by p38 Promotes Its Nuclear Localization in Response to Doxorubicin","target":"111-313-231-732-367","value":2},{"source":"AMPK: a nutrient and energy sensor that maintains energy homeostasis","target":"092-197-031-561-353","value":2},{"source":"AMPK: a nutrient and energy sensor that maintains energy homeostasis","target":"192-019-786-423-841","value":2},{"source":"AMPK: a nutrient and energy sensor that maintains energy homeostasis","target":"192-019-786-423-841","value":2},{"source":"AMPK: a nutrient and energy sensor that maintains energy homeostasis","target":"076-608-180-638-59X","value":2},{"source":"AMPK: a nutrient and energy sensor that maintains energy homeostasis","target":"175-263-797-963-040","value":2},{"source":"AMPK: a nutrient and energy sensor that maintains energy homeostasis","target":"092-197-031-561-353","value":2},{"source":"Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKK\u03B5 kinases.","target":"141-694-167-791-759","value":2},{"source":"Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKK\u03B5 kinases.","target":"081-203-444-563-604","value":2},{"source":"Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKK\u03B5 kinases.","target":"125-348-249-762-351","value":2},{"source":"Synthesis and structure-activity relationships of a novel series of pyrimidines as potent inhibitors of TBK1/IKK\u03B5 kinases.","target":"125-850-986-196-787","value":2},{"source":"Peptide inhibitors of the Keap1-Nrf2 protein-protein interaction","target":"119-397-162-706-860","value":2},{"source":"Small molecules that bind the Mdm2 RING stabilize and activate p53","target":"133-023-408-974-285","value":2},{"source":"Small molecules that bind the Mdm2 RING stabilize and activate p53","target":"039-847-299-166-952","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"076-641-402-312-988","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"102-485-198-725-150","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"168-829-456-947-639","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"098-813-369-162-741","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"023-180-369-416-862","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"189-473-046-734-005","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"019-633-684-883-828","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"174-501-376-407-235","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"129-062-448-949-030","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"162-916-741-322-002","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"080-026-305-809-343","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"016-698-167-713-829","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"091-325-080-234-401","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"032-206-614-235-635","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"143-271-017-351-983","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"169-312-245-869-778","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"089-818-979-077-305","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"187-517-157-601-239","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"111-583-988-147-450","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"058-026-435-099-506","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"153-651-762-444-327","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"159-766-711-047-610","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"058-933-099-316-100","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"023-452-662-674-373","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"047-432-030-246-04X","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"139-008-712-602-518","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"137-720-748-139-162","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"192-136-893-476-749","value":2},{"source":"Reduction in BACE1 decreases body weight, protects against diet-induced obesity and enhances insulin sensitivity in mice","target":"172-890-893-515-719","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"104-472-615-006-481","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"097-374-332-908-898","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"034-416-075-094-770","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"127-642-274-375-054","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"036-708-909-192-156","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"193-863-590-855-263","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"150-028-859-997-047","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"034-416-075-094-770","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"097-374-332-908-898","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"104-472-615-006-481","value":2},{"source":"AMP-Activated Protein Kinase: A Target for Drugs both Ancient and Modern","target":"132-394-716-226-832","value":2},{"source":"Changes in the ratio of free NEDD8 to ubiquitin triggers NEDDylation by ubiquitin enzymes","target":"168-483-508-794-377","value":2},{"source":"Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.","target":"131-238-819-455-784","value":2},{"source":"Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.","target":"155-402-461-387-483","value":2},{"source":"Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.","target":"040-389-070-176-191","value":2},{"source":"Fragment-based discovery of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors.","target":"076-478-479-475-120","value":2},{"source":"A multifunctional protease inhibitor to regulate endolysosomal function.","target":"031-461-589-086-771","value":2},{"source":"A multifunctional protease inhibitor to regulate endolysosomal function.","target":"190-195-697-065-907","value":2},{"source":"Design, Synthesis, and Structure\u2212Activity Relationship Exploration of 1-Substituted 4-Aroyl-3-hydroxy-5-phenyl-1H-pyrrol-2(5H)-one Analogues as Inhibitors of the Annexin A2\u2212S100A10 Protein Interaction","target":"034-190-802-321-708","value":2},{"source":"4-benzimidazolyl-3-phenylbutanoic acids as novel PIF-pocket-targeting allosteric inhibitors of protein kinase PKC\u03B6.","target":"130-316-719-983-242","value":2},{"source":"Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors","target":"076-478-479-475-120","value":2},{"source":"Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors","target":"040-389-070-176-191","value":2},{"source":"Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors","target":"036-668-261-470-040","value":2},{"source":"Optimisation of 6-substituted isoquinolin-1-amine based ROCK-I inhibitors","target":"183-767-289-461-131","value":2},{"source":"Design, Synthesis and Biological Evaluation of Novel Inhibitors of Trypanosoma brucei Pteridine Reductase 1","target":"107-556-164-321-147","value":2},{"source":"The inhibitory effect of phospholemman on the sodium pump requires its palmitoylation.","target":"106-594-488-484-12X","value":2},{"source":"SCF/\u03B2-TrCP promotes glycogen synthase kinase 3-dependent degradation of the Nrf2 transcription factor in a keap1-independent manner","target":"066-190-726-252-149","value":2},{"source":"Immunosuppressive but Non-LasR-Inducing Analogues of the Pseudomonas aeruginosa Quorum-Sensing Molecule N-(3-Oxododecanoyl)-L-homoserine Lactone","target":"140-900-012-438-14X","value":2},{"source":"Absolute SILAC-Compatible Expression Strain Allows Sumo-2 Copy Number Determination in Clinical Samples","target":"058-438-690-312-096","value":2},{"source":"Absolute SILAC-Compatible Expression Strain Allows Sumo-2 Copy Number Determination in Clinical Samples","target":"004-889-112-130-518","value":2},{"source":"Collateral sensitivity of multidrug-resistant cells to the orphan drug tiopronin.","target":"193-040-307-473-220","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"188-718-220-131-362","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"087-577-350-425-176","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"191-670-060-004-126","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"188-803-921-043-695","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"041-699-843-843-567","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"180-366-233-781-99X","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"156-653-831-632-101","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"051-324-518-696-462","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"161-487-188-181-03X","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"167-851-091-520-257","value":2},{"source":"Characterization of a selective inhibitor of the Parkinson\'s disease kinase LRRK2","target":"122-739-962-072-793","value":2},{"source":"ATP site-directed inhibitors of protein kinase CK2: an update.","target":"109-274-898-147-341","value":2},{"source":"Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3","target":"124-179-501-005-870","value":2},{"source":"Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3","target":"008-694-981-426-172","value":2},{"source":"Identification of Inhibitors of the Leishmania cdc2-Related Protein Kinase CRK3","target":"109-611-546-954-080","value":2},{"source":"Polyubiquitin binding to optineurin is required for optimal activation of TANK-binding kinase 1 and production of interferon \u03B2.","target":"004-378-254-734-355","value":2},{"source":"Polyubiquitin binding to optineurin is required for optimal activation of TANK-binding kinase 1 and production of interferon \u03B2.","target":"133-997-520-845-569","value":2},{"source":"Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.","target":"115-381-943-359-61X","value":2},{"source":"Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.","target":"022-078-711-389-998","value":2},{"source":"Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.","target":"132-854-391-972-865","value":2},{"source":"Substrate and Product Analogues as Human O-Glcnac Transferase Inhibitors.","target":"171-143-110-884-468","value":2},{"source":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","target":"003-946-199-636-328","value":2},{"source":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","target":"009-649-401-227-606","value":2},{"source":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","target":"170-042-571-881-121","value":2},{"source":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","target":"033-301-273-471-462","value":2},{"source":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","target":"040-826-560-477-838","value":2},{"source":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","target":"048-208-660-423-215","value":2},{"source":"The cytoprotective role of the Keap1\u2013Nrf2 pathway","target":"135-293-472-746-415","value":2},{"source":"Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors","target":"153-999-081-812-523","value":2},{"source":"Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors","target":"000-498-778-953-787","value":2},{"source":"Design, synthesis and biological evaluation of 6-pyridylmethylaminopurines as CDK inhibitors","target":"085-065-777-135-758","value":2},{"source":"Analgesic omega-Conotoxins CVIE and CVIF Selectively and Voltage-Dependently Block Recombinant and Native N-Type Calcium Channels (vol 77, pg 139, 2010)","target":"152-366-692-522-975","value":2},{"source":"Analgesic omega-Conotoxins CVIE and CVIF Selectively and Voltage-Dependently Block Recombinant and Native N-Type Calcium Channels (vol 77, pg 139, 2010)","target":"167-869-142-610-582","value":2},{"source":"NF-\u03BAB controls energy homeostasis and metabolic adaptation by upregulating mitochondrial respiration","target":"191-676-336-200-724","value":2},{"source":"Development of 18F-fluorinatable dendrons and their application to cancer cell targeting","target":"056-387-403-639-935","value":2},{"source":"The specificities of small molecule inhibitors of the TGF\xdf and BMP pathways","target":"066-841-401-628-941","value":2},{"source":"The specificities of small molecule inhibitors of the TGF\xdf and BMP pathways","target":"069-503-782-573-055","value":2},{"source":"The specificities of small molecule inhibitors of the TGF\xdf and BMP pathways","target":"028-137-796-142-577","value":2},{"source":"Catalysis by the nucleolytic ribozymes","target":"197-678-301-596-236","value":2},{"source":"Catalysis by the nucleolytic ribozymes","target":"147-466-934-435-143","value":2},{"source":"Catalysis by the nucleolytic ribozymes","target":"114-647-123-099-321","value":2},{"source":"Catalysis by the nucleolytic ribozymes","target":"058-829-130-504-901","value":2},{"source":"Catalysis by the nucleolytic ribozymes","target":"169-953-034-717-264","value":2},{"source":"Characterization of GSK2334470, a novel and highly specific inhibitor of PDK1","target":"028-012-588-449-727","value":2},{"source":"Characterization of GSK2334470, a novel and highly specific inhibitor of PDK1","target":"038-839-140-589-623","value":2},{"source":"N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases","target":"194-924-906-201-593","value":2},{"source":"N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases","target":"195-611-964-620-410","value":2},{"source":"N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases","target":"025-014-524-538-421","value":2},{"source":"N1-Benzyl substituted cambinol analogues as isozyme selective inhibitors of the sirtuin family of protein deacetylases","target":"025-014-524-538-421","value":2},{"source":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","target":"120-667-268-642-909","value":2},{"source":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","target":"163-117-320-460-138","value":2},{"source":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","target":"191-290-593-697-506","value":2},{"source":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","target":"118-339-847-530-982","value":2},{"source":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","target":"073-318-370-112-877","value":2},{"source":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","target":"113-828-920-381-078","value":2},{"source":"AMP-activated protein kinase\u2014an energy sensor that regulates all aspects of cell function","target":"048-983-957-537-421","value":2},{"source":"Optimisation of the Anti-Trypanosoma brucei Activity of the Opioid Agonist U50488","target":"073-531-962-083-670","value":2}]}');



const $0e16d1d92f054a3e$var$nodeCount = 1000;
const $0e16d1d92f054a3e$var$linkedNodeCount = 500;
const $0e16d1d92f054a3e$var$unlinkedNodeCount = $0e16d1d92f054a3e$var$nodeCount - $0e16d1d92f054a3e$var$linkedNodeCount;
const $0e16d1d92f054a3e$var$groupCount = 10;
const $0e16d1d92f054a3e$var$linkedNodes = (0, $e1083f20a85be6dc$export$7f1ebd623f131021)($0e16d1d92f054a3e$var$linkedNodeCount, (id)=>({
        id: id,
        group: 1,
        name: id.toString()
    }));
const $0e16d1d92f054a3e$var$unlinkedNodes = (0, $e1083f20a85be6dc$export$7f1ebd623f131021)($0e16d1d92f054a3e$var$unlinkedNodeCount, (id)=>({
        id: $0e16d1d92f054a3e$var$linkedNodeCount + id,
        group: 0,
        name: id.toString()
    }));
const $0e16d1d92f054a3e$var$data = {
    nodes: $0e16d1d92f054a3e$var$linkedNodes.concat($0e16d1d92f054a3e$var$unlinkedNodes),
    links: (0, $e1083f20a85be6dc$export$7f1ebd623f131021)(Math.floor(Math.random() * $0e16d1d92f054a3e$var$linkedNodeCount), ()=>{
        const source = Math.floor(Math.random() * ($0e16d1d92f054a3e$var$linkedNodeCount - 1));
        let target = Math.floor(Math.random() * ($0e16d1d92f054a3e$var$linkedNodeCount - 1));
        if (target === source) target = (target + 1) % $0e16d1d92f054a3e$var$linkedNodeCount;
        return {
            source: source,
            target: target
        };
    })
};
var $0e16d1d92f054a3e$export$2e2bcd8739ae039 = $0e16d1d92f054a3e$var$data;


const $14cbe1349367cc98$var$maxNodeChildCount = 9;
const $14cbe1349367cc98$var$levels = 3;
const $14cbe1349367cc98$var$nodes = [
    {
        id: 0,
        level: 0
    }
];
const $14cbe1349367cc98$var$links = [];
function $14cbe1349367cc98$var$addChildren(nodeIndex, level = 0) {
    const childCount = Math.ceil(Math.random() * $14cbe1349367cc98$var$maxNodeChildCount);
    for(let i = 0; i < childCount; i++){
        const id = $14cbe1349367cc98$var$nodes.length;
        $14cbe1349367cc98$var$nodes.push({
            id: id,
            level: level + 1,
            group: level + 1
        });
        $14cbe1349367cc98$var$links.push({
            source: nodeIndex,
            target: id
        });
        if (level < $14cbe1349367cc98$var$levels) $14cbe1349367cc98$var$addChildren(id, level + 1);
    }
}
$14cbe1349367cc98$var$addChildren(0);
const $14cbe1349367cc98$var$data = {
    nodes: $14cbe1349367cc98$var$nodes,
    links: $14cbe1349367cc98$var$links
};
var $14cbe1349367cc98$export$2e2bcd8739ae039 = $14cbe1349367cc98$var$data;



const $529524a779aacbff$var$gridSize = 20;
const $529524a779aacbff$var$total = $529524a779aacbff$var$gridSize ** 2;
const $529524a779aacbff$var$initPositions = false;
const $529524a779aacbff$var$width = 0.8;
const $529524a779aacbff$var$distance = $529524a779aacbff$var$width / ($529524a779aacbff$var$gridSize - 1);
const $529524a779aacbff$var$start = (1 - $529524a779aacbff$var$width) / 2;
const $529524a779aacbff$var$nodes = (0, $e1083f20a85be6dc$export$7f1ebd623f131021)($529524a779aacbff$var$total, (id)=>({
        id: id,
        ...$529524a779aacbff$var$initPositions ? {
            x: $529524a779aacbff$var$start + $529524a779aacbff$var$distance * (id % $529524a779aacbff$var$gridSize),
            y: $529524a779aacbff$var$start + $529524a779aacbff$var$distance * (Math.ceil(id / $529524a779aacbff$var$gridSize) - 1)
        } : null
    }));
const $529524a779aacbff$var$links = [];
for(let i = 0; i < $529524a779aacbff$var$total; i++){
    if ((i + 1) % $529524a779aacbff$var$gridSize) $529524a779aacbff$var$links.push({
        source: i,
        target: i + 1
    });
    if (i + $529524a779aacbff$var$gridSize < $529524a779aacbff$var$total) $529524a779aacbff$var$links.push({
        source: i,
        target: i + $529524a779aacbff$var$gridSize
    });
}
const $529524a779aacbff$var$data = {
    nodes: $529524a779aacbff$var$nodes,
    links: $529524a779aacbff$var$links
};
var $529524a779aacbff$export$2e2bcd8739ae039 = $529524a779aacbff$var$data;



const $209513ea564a5f29$var$count = 130;
const $209513ea564a5f29$var$nodes = (0, $e1083f20a85be6dc$export$7f1ebd623f131021)($209513ea564a5f29$var$count + 1, (id)=>({
        id: id,
        group: id ? 1 : 0
    }));
const $209513ea564a5f29$var$links = (0, $e1083f20a85be6dc$export$7f1ebd623f131021)($209513ea564a5f29$var$count, (i)=>({
        source: 0,
        target: i + 1
    }));
const $209513ea564a5f29$var$data = {
    nodes: $209513ea564a5f29$var$nodes,
    links: $209513ea564a5f29$var$links
};
var $209513ea564a5f29$export$2e2bcd8739ae039 = $209513ea564a5f29$var$data;



const $3c02c760ffff56a0$var$count = 100;
const $3c02c760ffff56a0$var$nodes = (0, $e1083f20a85be6dc$export$7f1ebd623f131021)($3c02c760ffff56a0$var$count, (id)=>({
        id: id
    }));
const $3c02c760ffff56a0$var$links = (0, $e1083f20a85be6dc$export$7f1ebd623f131021)($3c02c760ffff56a0$var$count, (i)=>({
        source: i,
        target: (i + 1) % $3c02c760ffff56a0$var$count
    }));
const $3c02c760ffff56a0$var$data = {
    nodes: $3c02c760ffff56a0$var$nodes,
    links: $3c02c760ffff56a0$var$links
};
var $3c02c760ffff56a0$export$2e2bcd8739ae039 = $3c02c760ffff56a0$var$data;


const $340de7a66a8515a7$var$count = 20;
const $340de7a66a8515a7$var$minRadius = 2;
const $340de7a66a8515a7$var$maxRadius = 50;
const $340de7a66a8515a7$var$nodes = [
    {
        id: 0,
        radius: 4,
        group: 1
    },
    {
        id: 1,
        radius: 20,
        group: 2
    },
    {
        id: 2,
        radius: 4,
        group: 1
    },
    {
        id: 3,
        radius: 25,
        group: 2
    },
    {
        id: 4,
        radius: 2,
        group: 1
    },
    {
        id: 5,
        radius: 10,
        group: 3
    },
    {
        id: 6,
        radius: 10,
        group: 3
    },
    {
        id: 7,
        radius: 15,
        group: 3
    },
    {
        id: 8,
        radius: 44,
        group: 1
    },
    {
        id: 8,
        radius: 64,
        group: 1
    },
    {
        id: 8,
        radius: 4,
        group: 1
    },
    {
        id: 8,
        radius: 4,
        group: 1
    },
    {
        id: 8,
        radius: 4,
        group: 1
    }
];
const $340de7a66a8515a7$var$links = [];
const $340de7a66a8515a7$var$data = {
    nodes: $340de7a66a8515a7$var$nodes,
    links: $340de7a66a8515a7$var$links
};
var $340de7a66a8515a7$export$2e2bcd8739ae039 = $340de7a66a8515a7$var$data;


const $e6b77000f6bff1dd$var$testData = [
    {
        id: 'les_miserables',
        name: 'Les Miserables',
        data: (0, (/*@__PURE__*/$parcel$interopDefault($610202b23933f097$exports)))
    },
    {
        id: 'essays',
        name: 'Essays',
        data: (0, (/*@__PURE__*/$parcel$interopDefault($15f6d49129e3bec6$exports)))
    },
    {
        id: 'simple',
        name: 'Simple data',
        data: (0, $0e16d1d92f054a3e$export$2e2bcd8739ae039)
    },
    {
        id: 'tree',
        name: 'Tree',
        data: (0, $14cbe1349367cc98$export$2e2bcd8739ae039)
    },
    {
        id: 'grid',
        name: 'Grid',
        data: (0, $529524a779aacbff$export$2e2bcd8739ae039)
    },
    {
        id: 'central',
        name: 'Central',
        data: (0, $209513ea564a5f29$export$2e2bcd8739ae039)
    },
    {
        id: 'chain',
        name: 'Chain',
        data: (0, $3c02c760ffff56a0$export$2e2bcd8739ae039)
    },
    {
        id: 'collision',
        name: 'Collision',
        data: (0, $340de7a66a8515a7$export$2e2bcd8739ae039)
    }
].map(({ id: id, name: name, data: data })=>({
        id: id,
        name: name,
        data: {
            nodes: data.nodes,
            links: $e6b77000f6bff1dd$var$getLinksForNodes(data)
        }
    }));
function $e6b77000f6bff1dd$var$getLinksForNodes({ nodes: nodes, links: links }) {
    const nodeIndexes = new Map();
    nodes.forEach(({ id: id }, i)=>nodeIndexes.set(id, i));
    return links.map((link)=>({
            source: nodeIndexes.get(link.source),
            target: nodeIndexes.get(link.target)
        }));
}
var $e6b77000f6bff1dd$export$2e2bcd8739ae039 = $e6b77000f6bff1dd$var$testData;


const $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE = 0.05;
const $01dabe55fddff864$var$THUMB_RADIUS = 8;
const $01dabe55fddff864$var$TICK_WIDTH = 2;
const $01dabe55fddff864$var$TICK_COLOR = 'rgba(0,0,0,.2)';
const $01dabe55fddff864$var$FAR_VALUES_DISTANCE = 0.2; // values are considered far from each other if they are at least a fifth of the width of the input apart
class $01dabe55fddff864$export$2e2bcd8739ae039 extends HTMLElement {
    static formAssociated = true;
    internals;
    min;
    max;
    #input = null;
    #backgroundStyle = null;
    #snap = $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE;
    #prevValue = null;
    #prevSnapValue = null;
    #tickValues = null;
    #snapDistance = null;
    #background = null;
    #thumbColor = null;
    #snapDisabledTick = null;
    #resizeObserver;
    constructor(){
        super();
        this.attachShadow({
            mode: 'open',
            delegatesFocus: true
        });
        this.shadowRoot.innerHTML = `
          <style>
            input[type="range"] {
              width: 100%;
              appearance: none;
              -webkit-appearance: none; /* remove iOS default */
              background: transparent;
              border: none;
              margin: 2px;
              cursor: pointer;
            }

            input[type="range"]::-webkit-slider-thumb {
              appearance: none;
              -webkit-appearance: none;
              width: ${$01dabe55fddff864$var$THUMB_RADIUS * 2}px;
              height: ${$01dabe55fddff864$var$THUMB_RADIUS * 2}px;
              border-radius: 50%;
              background: var(--color-input);
              cursor: pointer;
              border: none;
              margin-top: -4px;
              z-index: 10;
              box-shadow: 0 0 5px rgba(0,0,0,.5)
            }

            input[type="range"]::-webkit-slider-thumb:hover {
              background: var(--color-input-hover);
            }
              
            input[type="range"]:active::-webkit-slider-thumb {
              background: var(--color-input-active);
            }

            input[type="range"]::-webkit-slider-runnable-track {
              height: 8px;
              border-radius: 4px;
              margin: 0;
            }
          </style>
          <style id="background"></style>
          <input type="range">
        `;
        this.#input = this.shadowRoot.querySelector('input[type="range"]');
        this.#backgroundStyle = this.shadowRoot.querySelector('#background');
        this.#snap = $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE;
        this.#prevSnapValue = null;
        this.internals = this.attachInternals();
    }
    static get observedAttributes() {
        return [
            'min',
            'max',
            'value',
            'step',
            'snap',
            'background',
            'thumbcolor'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'snap') this.#tickValues = this.getTickValues();
        else if (this.#input) this.#input[name] = newVal;
        if (name === 'min' || name === 'max') this[name] = Number(newVal);
        let value;
        if (name === 'value') value = Number(newVal);
        if (name === 'background') this.#background = newVal;
        if (name === 'thumbcolor') this.#thumbColor = newVal;
        if (this.min != null && this.max != null) {
            if (this.min > this.max) {
                this.max = this.min;
                this.#input.max = String(this.min);
            }
            this.#snapDistance = (this.max - this.min) * this.#snap || $01dabe55fddff864$var$DEFAULT_SNAP_DISTANCE;
            if (this.#tickValues && this.value != null) {
                const snappedValue = this.getClosestTick(value);
                if (snappedValue != null) this.#prevSnapValue = snappedValue;
            }
        }
        this.#setStyle();
    }
    get value() {
        return Number(this.#input.value);
    }
    set value(v) {
        this.#input.value = String(v);
        this.#setStyle();
    }
    connectedCallback() {
        [
            'min',
            'max',
            'value',
            'step'
        ].forEach((attr)=>{
            if (this.hasAttribute(attr)) this.#input[attr] = this.getAttribute(attr);
        });
        this.#tickValues = this.getTickValues();
        this.#resizeObserver = new ResizeObserver((entries)=>{
            for (let entry of entries){
                const width = entry.contentRect.width;
                this.#setStyle();
            }
        });
        this.#resizeObserver.observe(this.#input);
        this.#input.addEventListener('input', ()=>this.handleInput());
        this.#input.addEventListener('keydown', (e)=>this.handleKeydown(e));
        this.#input.addEventListener('change', ()=>this.#snapDisabledTick = null);
        this.tabIndex = 0;
    }
    disconnectedCallback() {
        this.#resizeObserver.unobserve(this);
    }
    getTickValues() {
        const ticks = this.getAttribute('snap');
        const ticksMatch = ticks?.match(/\d+(\.\d+)?/g);
        if (!ticksMatch) return [];
        return ticksMatch.map(Number).filter((n)=>!isNaN(n)).sort();
    }
    #shouldAvoidSnap(newValue, closestTick) {
        if (closestTick == null) closestTick = this.getClosestTick(newValue);
        if (closestTick == null) return true;
        // If moving away from the snap value, don't snap:
        const distanceFromTick = Math.abs(newValue - closestTick);
        if (distanceFromTick >= this.#snapDistance / 2 && distanceFromTick > Math.abs(this.#prevValue - closestTick)) return true;
        return false;
    }
    // Checks whether two values are far apart,
    #areValuesFar(value1, value2) {
        const distance = Math.abs(value1 - value2) / (this.max - this.min);
        return distance >= $01dabe55fddff864$var$FAR_VALUES_DISTANCE;
    }
    focus() {
        this.#input.focus();
    }
    blur() {
        this.#input.blur();
    }
    handleInput() {
        const value = Number(this.#input.value);
        const closestTick = this.getClosestTick(value);
        this.internals.setFormValue(this.#input.value);
        if (closestTick != null && this.#snapDisabledTick !== closestTick && this.#shouldAvoidSnap(value, closestTick)) this.#snapDisabledTick = closestTick;
        if (closestTick !== this.#snapDisabledTick) {
            if (closestTick !== null) {
                this.#input.value = String(closestTick);
                if (closestTick !== this.#prevSnapValue) {
                    this.#vibrate();
                    this.#prevSnapValue = closestTick;
                }
            } else if (this.#prevSnapValue != null) this.#prevSnapValue = null;
        }
        if (this.#snapDisabledTick != null && closestTick == null && this.#areValuesFar(value, this.#snapDisabledTick)) this.#snapDisabledTick = null;
        this.#setStyle();
        this.#prevValue = value;
        this.dispatchEvent(new CustomEvent('input', {
            detail: {
                value: this.#input.value
            }
        }));
    }
    handleKeydown(event) {
        event.preventDefault();
        const step = Number(this.#input.step || 1);
        const value = Number(this.#input.value);
        let newValue;
        if (event.key === 'ArrowLeft') newValue = Math.max(this.min, value - step);
        else if (event.key === 'ArrowRight') newValue = Math.min(this.max, value + step);
        else if (event.key === 'ArrowUp') {
            const next = this.#tickValues.find((t)=>t > value);
            if (next !== undefined) newValue = next;
            else if (value !== this.max) // no next tick found, go to max
            newValue = this.max;
        } else if (event.key === 'ArrowDown') {
            const reversed = [
                ...this.#tickValues
            ].reverse();
            const prev = reversed.find((t)=>t < value);
            if (prev !== undefined) newValue = prev;
            else if (value !== this.min) newValue = this.min;
        }
        if (newValue != null) {
            this.value = newValue;
            this.#prevValue = newValue;
            // emit event and prevent default for arrow keys
            this.dispatchEvent(new CustomEvent('input', {
                detail: {
                    value: newValue
                },
                bubbles: true,
                composed: true
            }));
        }
        return false;
    }
    getClosestTick(value) {
        if (!this.#tickValues || this.#tickValues.length === 0) return null;
        for (const tickValue of this.#tickValues){
            const distance = Math.abs(value - tickValue);
            if (distance <= this.#snapDistance) return tickValue;
        }
        return null;
    }
    #vibrate() {
        if ('vibrate' in navigator) navigator.vibrate(10);
    }
    #setStyle() {
        const inputWidth = this.#input.clientWidth;
        if (!inputWidth) return;
        const valueInRange = this.value - this.min;
        const range = this.max - this.min;
        const availableWidth = inputWidth - 2 * $01dabe55fddff864$var$THUMB_RADIUS;
        const valueWidth = $01dabe55fddff864$var$THUMB_RADIUS + availableWidth * valueInRange / range;
        // The center of the thumb of the range input doesn't reach 0 and 100%, so the actual range to display leaves out the thumb's radius on the left and right.
        // Due to this, the ticks are placed in the constricted range of [THUMB_RADIUS::inputWidth - 2 * THUMB_RADIUS]
        const tickPositions = this.#tickValues?.filter((v)=>v !== this.min && v !== this.max).map((v)=>$01dabe55fddff864$var$THUMB_RADIUS + availableWidth * (v - this.min) / range - $01dabe55fddff864$var$TICK_WIDTH / 2);
        const tickPositionsInGradient = tickPositions?.map((p)=>`transparent ${p}px, ${$01dabe55fddff864$var$TICK_COLOR} ${p}px, ${$01dabe55fddff864$var$TICK_COLOR} ${p + $01dabe55fddff864$var$TICK_WIDTH}px, transparent ${p + $01dabe55fddff864$var$TICK_WIDTH}px`).join(', ');
        const ticksBackground = tickPositions?.length ? `linear-gradient(to right, ${tickPositionsInGradient}), ` : null;
        const styles = [
            `input[type="range"]::-webkit-slider-runnable-track {
        background: ${ticksBackground ? ticksBackground : ''}${this.#background ?? `linear-gradient(to right, var(--color-input) ${valueWidth}px, #ddd ${valueWidth}px)`};
      }${this.#background ? '' : `
       input[type="range"]:hover::-webkit-slider-runnable-track {
        background: ${ticksBackground ? ticksBackground : ''}linear-gradient(to right, var(--color-input-hover) ${valueWidth}px, #ddd ${valueWidth}px);
      }
        input[type="range"]:active::-webkit-slider-runnable-track {
        background: ${ticksBackground ? ticksBackground : ''}linear-gradient(to right, var(--color-input-active) ${valueWidth}px, #ddd ${valueWidth}px);
      }`}`
        ];
        if (this.#thumbColor != null) styles.push(`input[type="range"]::-webkit-slider-thumb { background: ${this.#thumbColor} !important}`);
        this.#backgroundStyle.innerHTML = styles.join('\n');
    }
}
customElements.define('string-art-range-input', $01dabe55fddff864$export$2e2bcd8739ae039);


const $c6b5ffbe96e4aeb4$var$DEFAULT_THUMB_COLOR = 'white';
const $c6b5ffbe96e4aeb4$var$FULL_GAMUT_GRADIENT = 'linear-gradient(to right in hsl longer hue, hsl(1 100 50), hsl(360 100 50))';
class $c6b5ffbe96e4aeb4$export$2e2bcd8739ae039 extends HTMLElement {
    static formAssociated = true;
    internals;
    start = 1;
    colorThumb = false;
    reverse = false;
    type = 'hue';
    #input = null;
    constructor(){
        super();
        this.attachShadow({
            mode: 'open',
            delegatesFocus: true
        });
        this.shadowRoot.innerHTML = `
        <string-art-range-input min="1" max="360" step="1" />
    `;
        this.#input = this.shadowRoot.querySelector('string-art-range-input');
        this.internals = this.attachInternals();
    }
    static get observedAttributes() {
        return [
            'start',
            'colorthumb',
            'value',
            'reverse',
            'type'
        ];
    }
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'value') this.value = newVal;
        if (name === 'start') {
            this.start = parseInt(newVal, 10);
            this.#setBackground();
        }
        if (name === 'reverse') {
            this.reverse = !!newVal;
            this.#setBackground();
        }
        if (name === 'colorthumb') {
            this.colorThumb = !!newVal;
            this.#setThumbColor();
        // Update color thumb
        }
        if (name === 'type') {
            this.type = newVal === 'range' ? 'range' : 'hue';
            this.#setBackground();
        }
    }
    get value() {
        return this.#input.value;
    }
    set value(v) {
        this.#input.value = v;
        this.#setBackground();
        if (this.colorThumb) this.#setThumbColor();
    }
    connectedCallback() {
        if (this.hasAttribute('value')) this.value = parseInt(this.getAttribute('value'));
        if (this.hasAttribute('colorthumb')) this.colorThumb = true;
        this.#setThumbColor();
        this.#input.addEventListener('input', (e)=>this.#handleInput(e));
    }
    #handleInput(e) {
        const value = this.value;
        this.internals.setFormValue(String(value));
        this.dispatchEvent(new CustomEvent('input', {
            detail: {
                value: value
            }
        }));
        this.#setBackground();
        this.#setThumbColor();
    }
    disconnectedCallback() {
    // Destroy EditorControls here
    }
    focus() {}
    blur() {}
    #setBackground() {
        const background = this.type === 'range' ? `linear-gradient(to ${this.reverse ? 'left' : 'right'} in hsl ${this.value >= 180 ? 'longer' : 'shorter'} hue, hsl(${this.start} 100 50), hsl(${// Fixes a bug in Chrome, that for a 180 deg hue gradient, it always goes in reverse
        this.start + (this.value === 180 ? 181 : this.value)} 100 50))` : $c6b5ffbe96e4aeb4$var$FULL_GAMUT_GRADIENT;
        this.#input.setAttribute('background', background);
    }
    #setThumbColor() {
        const thumbColor = this.colorThumb ? `hsl(${this.value}deg 100 50)` : $c6b5ffbe96e4aeb4$var$DEFAULT_THUMB_COLOR;
        this.#input.setAttribute('thumbcolor', thumbColor);
    }
}
customElements.define('string-art-hue-input', $c6b5ffbe96e4aeb4$export$2e2bcd8739ae039);


var $c743accf33ce06b6$exports = {};
$c743accf33ce06b6$exports = ":root{--color-accent:#ff218f;--color-accent-hover:#b11b66;--color-buttons-dialog:#212124;--color-canvas-background:#0e0e0e;--color-config:#212124;--color-gray3:#262629;--color-header:#2b2b31;--color-lighter:#ffffff87;--color-link:#68c0ff;--color-link-hover:#85ccff;--color-player:#222226;--color-text:White;--color-text-hover:#85ccff;--color-input:#c51880;--color-input-hover:#961663;--color-input-active:#e20c8c;--color-dialog-background:#212124;--color-error:#c00;--horizontal-padding:16px;--vertical-padding:12px;--logo1:#9892ff;--logo1-active:#c5c2ff;--logo2:#d4c1ff;--border-light:solid 1px #3a3a3a;--border-lighter:dotted 1px #505050;--border-dialog:solid 1px #fff3;--circular_button_width:38px;--controls-height:50px;--header-height:45px;--select-height:49px;--sidebar-form-padding-top:16px;--sidebar-width:270px;--player-mobile-height:100px;--responsive-width:800px}span{white-space:nowrap}input{appearance:none;cursor:pointer;vertical-align:middle;border:2px solid #666;border-radius:2px;width:18px;height:18px;margin:0 2px;position:relative}input:checked{background-color:var(--color-input-active);border-color:var(--color-input)}input:checked:after{content:\"\";border:2px solid #fff;border-width:0 2px 2px 0;width:4px;height:11px;position:absolute;top:-1px;left:4px;transform:rotate(36deg)}label{margin-top:0;margin-inline-start:2px;font-size:14px;display:inline-block;position:relative;top:1px}";


const $3ce3bee09e11519c$var$sheet = new CSSStyleSheet();
$3ce3bee09e11519c$var$sheet.replaceSync(String($c743accf33ce06b6$exports));
class $3ce3bee09e11519c$export$2e2bcd8739ae039 extends HTMLElement {
    static formAssociated = true;
    internals;
    #checked;
    disabled = false;
    #label;
    #input;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open',
            delegatesFocus: true
        });
        shadow.adoptedStyleSheets = [
            $3ce3bee09e11519c$var$sheet
        ];
        this.shadowRoot.innerHTML = `
          <span>
            <input id="checkbox" type="checkbox">
            <label for="checkbox"></label>
          </span>
        `;
        this.#input = shadow.querySelector('input');
        this.#label = shadow.querySelector('label');
        this.internals = this.attachInternals();
    }
    static get observedAttributes() {
        return [
            'checked',
            'label',
            'disabled',
            'name'
        ];
    }
    attributeChangedCallback() {
        this.syncAttributes();
    }
    get checked() {
        return this.#checked;
    }
    set checked(v) {
        if (this.#checked = v) this.#input.checked = true;
        else this.#input.checked = false;
        this.internals.setFormValue(this.#checked ? 'on' : null);
    }
    get value() {
        return this.checked;
    }
    set value(v) {
        this.checked = v;
    }
    connectedCallback() {
        this.syncAttributes();
        this.#input.addEventListener('input', ()=>{
            this.#checked = this.#input.checked;
            this.internals.setFormValue(this.#checked ? 'on' : null);
            this.dispatchEvent(new CustomEvent('input', {
                detail: {
                    checked: this.#checked
                }
            }));
            this.dispatchEvent(new CustomEvent('change', {
                detail: {
                    checked: this.#checked
                },
                bubbles: true
            }));
        });
        this.internals.setFormValue(this.#checked ? 'on' : null);
        this.tabIndex = 0;
    }
    syncAttributes() {
        if (this.hasAttribute('label')) this.#label.textContent = this.hasAttribute('label') ? this.getAttribute('label') : '';
        if (this.hasAttribute('checked')) this.checked = true;
        if (this.hasAttribute('disabled')) this.disabled = true;
        if (this.hasAttribute('name')) this.internals.setFormValue(this.#checked ? 'on' : null);
    }
    focus() {
        this.#input.focus();
    }
    blur() {
        this.#input.blur();
    }
}
customElements.define('string-art-checkbox', $3ce3bee09e11519c$export$2e2bcd8739ae039);


var $2d2165ae7b4acbcd$exports = {};
$2d2165ae7b4acbcd$exports = "fieldset{border:var(--border-light);background:#ffffff08;border-radius:9px;padding-inline:.5em}fieldset.noborder{border:none;padding-inline:0}fieldset>legend{cursor:pointer;opacity:.8}fieldset>legend:hover{opacity:1}div{padding-top:8px}fieldset.minimized{background:0 0;border:none;padding:0}fieldset.minimized>legend{padding:0;transform:translate(-6px)}fieldset.minimized>div{display:none}legend:before{content:\"\";opacity:.7;vertical-align:top;margin-inline-end:2px;font-family:string_art_studio;font-size:20px;display:inline-block}fieldset.minimized>legend:before{transform:rotate(-90deg)}";


const $4a7965eeea97d4bb$var$sheet = new CSSStyleSheet();
$4a7965eeea97d4bb$var$sheet.replaceSync(String($2d2165ae7b4acbcd$exports));
const $4a7965eeea97d4bb$var$MINIMIZED_CLASS = 'minimized';
class $4a7965eeea97d4bb$export$dbf21a0adc6a9ee0 extends HTMLElement {
    #legend;
    #fieldset;
    constructor(){
        super();
        const shadow = this.attachShadow({
            mode: 'open'
        });
        shadow.adoptedStyleSheets = [
            $4a7965eeea97d4bb$var$sheet
        ];
        this.shadowRoot.innerHTML = `
      <fieldset>
        <legend></legend>
        <div>
            <slot></slot>
        </div>
      </fieldset>
      `;
        this.#legend = shadow.querySelector('legend');
        this.#fieldset = shadow.querySelector('fieldset');
        this.#legend.addEventListener('click', ()=>this.toggle());
    }
    static get observedAttributes() {
        return [
            'legend',
            'minimized',
            'noborder'
        ];
    }
    connectedCallback() {
        this.syncAttributes();
    }
    attributeChangedCallback() {
        this.syncAttributes();
    }
    syncAttributes() {
        if (this.hasAttribute('legend')) this.#legend.textContent = this.getAttribute('legend');
        else {
            this.#fieldset.classList.remove($4a7965eeea97d4bb$var$MINIMIZED_CLASS);
            this.#legend.textContent = '';
        }
        if (this.hasAttribute($4a7965eeea97d4bb$var$MINIMIZED_CLASS)) this.#fieldset.classList.add($4a7965eeea97d4bb$var$MINIMIZED_CLASS);
        else this.#fieldset.classList.remove($4a7965eeea97d4bb$var$MINIMIZED_CLASS);
        if (this.hasAttribute('noborder')) this.#fieldset.classList.add('noborder');
        else this.#fieldset.classList.remove('noborder');
    }
    notifyChange() {
        this.dispatchEvent(new CustomEvent('change', {
            detail: {
                isExpanded: this.#fieldset.classList.contains($4a7965eeea97d4bb$var$MINIMIZED_CLASS)
            },
            bubbles: true
        }));
    }
    toggle() {
        this.#fieldset.classList.toggle($4a7965eeea97d4bb$var$MINIMIZED_CLASS);
        this.notifyChange();
    }
    open() {
        this.#fieldset.classList.remove($4a7965eeea97d4bb$var$MINIMIZED_CLASS);
        this.notifyChange();
    }
    close() {
        this.#fieldset.classList.add($4a7965eeea97d4bb$var$MINIMIZED_CLASS);
        this.notifyChange();
    }
}
customElements.define('expandable-panel', $4a7965eeea97d4bb$export$dbf21a0adc6a9ee0);







function $82491cd867e5eaaf$export$f823a0c1cf7adf68(element) {
    element.removeAttribute('hidden');
}
function $82491cd867e5eaaf$export$fe8985bb6374093c(element) {
    element.setAttribute('hidden', 'hidden');
}
function $82491cd867e5eaaf$export$1a3b688c8bc0de17(element, isHidden) {
    if (isHidden != null) isHidden ? $82491cd867e5eaaf$export$fe8985bb6374093c(element) : $82491cd867e5eaaf$export$f823a0c1cf7adf68(element);
    else if (element.hasAttribute('hidden')) $82491cd867e5eaaf$export$f823a0c1cf7adf68(element);
    else $82491cd867e5eaaf$export$fe8985bb6374093c(element);
}



const $83678c3c8d354007$var$STATE_LOCAL_STORAGE_KEY = 'controls_state';
const $83678c3c8d354007$var$RANGE_SCROLL_LOCK_TIMEOUT = 120;
let $83678c3c8d354007$var$inputTimeout;
class $83678c3c8d354007$export$2e2bcd8739ae039 extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    parentElement;
    config;
    controlsConfig;
    state;
    controlsElement;
    controlElements;
    #postponeRangeInput;
    #postponeRangeInputTimeout;
    #wrappedOnInput;
    #wrappedOnTouchStart;
    #wrappedOnTouchEnd;
    #wrappedOnRangeScroll;
    #currentInputRange;
    #currentInputRangeValue;
    #rangeLockTimeout;
    #lockRange;
    #boundToggleFieldset;
    constructor(parentElement, controlsConfig, config){
        super(), this.parentElement = parentElement, this.controlElements = {}, this.#postponeRangeInput = false, this.#lockRange = false;
        this.controlsElement = document.createElement('div');
        this.controlsElement.classList.add('controls');
        parentElement.appendChild(this.controlsElement);
        this.config = config;
        this.controlsConfig = controlsConfig;
        this.state = this._getState() ?? {
            groups: {}
        };
        this.#wrappedOnInput = this.#onInput.bind(this);
        this.controlsElement.addEventListener('input', this.#wrappedOnInput);
        this.#wrappedOnTouchStart = this.#onTouchStart.bind(this);
        this.controlsElement.addEventListener('touchstart', this.#wrappedOnTouchStart, {
            passive: true
        });
        this.controlsElement.addEventListener('mousedown', this.#onMouseDown);
        this.#boundToggleFieldset = this.#toggleFieldset.bind(this);
        this.controlElements = {};
        this.renderControls();
    }
    destroy() {
        this.controlsElement.removeEventListener('input', this.#wrappedOnInput);
        this.controlsElement.removeEventListener('touchstart', this.#wrappedOnTouchStart);
        this.controlsElement.removeEventListener('mousedown', this.#onMouseDown);
        this.controlsElement.innerHTML = '';
    }
    #toggleFieldset(e) {
        if (e.target.nodeName === 'LEGEND') {
            e.target.parentElement.classList.toggle('minimized');
            const groupId = e.target.parentElement.dataset.group;
            this.state = {
                ...this.state,
                groups: {
                    ...this.state.groups,
                    [groupId]: !e.target.parentElement.classList.contains('minimized')
                }
            };
            this._updateState(this.state);
        }
    }
    #toggleFieldSetOnEnter(e) {
        if (e.target.nodeName === 'LEGEND' && e.key === 'Enter') this.#toggleFieldset(e);
    }
    #onMouseDown() {
        // Clearing selection when starting to click in the controls, do avoid a buggy behavior,
        // when if a control's display value was selected (can happen by mistake), the drag of range input doesn't work.
        const selection = window.getSelection();
        if (selection) selection.removeAllRanges();
    }
    /**
   * Needed for range inputs, to avoid changing the value when the user drags to
   * scroll and accidentally touches a range input when intending to scroll.
   * @param {Event} e
   */ #onTouchStart(e) {
        if ($83678c3c8d354007$var$isRangeInput(e.target)) {
            this.#postponeRangeInput = true;
            this.#currentInputRange = e.target;
            this.#currentInputRangeValue = e.target.value;
            this.#rangeLockTimeout = window.setTimeout(()=>{
                this.#postponeRangeInput = false;
            }, $83678c3c8d354007$var$RANGE_SCROLL_LOCK_TIMEOUT);
            this.#wrappedOnTouchEnd = this.#onTouchEnd.bind(this);
            document.body.addEventListener('touchend', this.#wrappedOnTouchEnd, {
                passive: true
            });
            this.#wrappedOnRangeScroll = this.#onRangeScroll.bind(this);
            this.parentElement.addEventListener('scroll', this.#wrappedOnRangeScroll);
        }
    }
    #onTouchEnd() {
        document.body.removeEventListener('touchend', this.#wrappedOnTouchEnd);
        this.parentElement.removeEventListener('scroll', this.#wrappedOnRangeScroll);
        if (this.#lockRange) {
            this.#lockRange = false;
            if (this.#currentInputRange) this.#currentInputRange.value = this.#currentInputRangeValue;
        }
        this.#currentInputRange = this.#currentInputRangeValue = null;
    }
    #onRangeScroll() {
        this.#lockRange = true;
    }
    #onInput(e) {
        clearTimeout($83678c3c8d354007$var$inputTimeout);
        clearTimeout(this.#postponeRangeInputTimeout);
        if (this.#postponeRangeInput && $83678c3c8d354007$var$isRangeInput(e.target)) {
            e.preventDefault();
            this.#postponeRangeInputTimeout = window.setTimeout(()=>{
                this.#onInput(e);
            }, $83678c3c8d354007$var$RANGE_SCROLL_LOCK_TIMEOUT);
            return false;
        }
        if (this.#lockRange) {
            e.preventDefault();
            return false;
        }
        if (e.target instanceof HTMLInputElement || e.target instanceof (0, $3ce3bee09e11519c$export$2e2bcd8739ae039) || $83678c3c8d354007$var$isRangeInput(e.target) || e.target instanceof HTMLSelectElement) this.updateInput({
            inputElement: e.target,
            originalEvent: e,
            deferChange: true
        });
    }
    updateControlDisplayValue(controlKey) {
        const { config: config, displayValueElement: displayValueElement, input: input } = this.controlElements[controlKey];
        if (displayValueElement) {
            const formattedValue = config.displayValue ? config.displayValue(this.config) : input.value;
            displayValueElement.innerText = String(formattedValue);
        }
    }
    updateInput({ inputElement: inputElement, originalEvent: originalEvent, deferChange: deferChange = true }) {
        const controlKey = inputElement.id.replace(/^config_/, '');
        const inputValue = $83678c3c8d354007$var$getInputValue(inputElement);
        if (this.config[controlKey] === inputValue) return;
        const eventData = {
            control: this.controlElements[controlKey].config,
            value: inputValue,
            originalEvent: originalEvent
        };
        this.emit('input', eventData);
        const triggerChange = ()=>{
            this.emit('change', eventData);
            this.updateControlsVisibility();
            this.updateControlsLabels();
        };
        this.updateControlsAttributes();
        this.updateControlDisplayValue(controlKey);
        if (deferChange) $83678c3c8d354007$var$inputTimeout = window.setTimeout(triggerChange, 100);
        else triggerChange();
    }
    _getState() {
        const state = localStorage.getItem($83678c3c8d354007$var$STATE_LOCAL_STORAGE_KEY);
        if (state) try {
            return JSON.parse(state);
        } catch (e) {
            return null;
        }
        return null;
    }
    _updateState(newState) {
        if (newState) localStorage.setItem($83678c3c8d354007$var$STATE_LOCAL_STORAGE_KEY, JSON.stringify(newState));
        else localStorage.removeItem($83678c3c8d354007$var$STATE_LOCAL_STORAGE_KEY);
    }
    updateControlsAttributes(controlsConfig) {
        if (!controlsConfig) controlsConfig = this.controlsConfig;
        controlsConfig.forEach((control)=>{
            if (control.type === 'group') this.updateControlsAttributes(control.children);
            else if (control.attr) {
                const functionAttrs = Object.entries(control.attr).filter(([_, value])=>value instanceof Function);
                if (functionAttrs.length) {
                    const inputEl = this.controlElements[control.key].input;
                    if (inputEl) functionAttrs.forEach(([name, attributeValueFn])=>{
                        const newAttrValue = this.getConfigValue(attributeValueFn, this.config);
                        if (newAttrValue != inputEl.getAttribute(name)) {
                            inputEl.setAttribute(name, String(newAttrValue));
                            // If the min or max of the input changed and they're not within the new min/max, update the value of the input
                            if (name === 'min' && inputEl.value < newAttrValue || name === 'max' && inputEl.value > newAttrValue) {
                                inputEl.value = String(newAttrValue);
                                clearTimeout(inputEl.updateTimeout);
                                inputEl.updateTimeout = window.setTimeout(()=>{
                                    this.updateInput({
                                        inputElement: inputEl
                                    });
                                }, 100);
                            } else this.updateControlDisplayValue(control.key);
                        }
                    });
                }
            }
        });
    }
    updateControlsLabels(controlsConfig) {
        (controlsConfig ?? this.controlsConfig).forEach((control)=>{
            if (control.label instanceof Function) {
                const { label: labelEl, element: element } = this.controlElements[control.key];
                const labelText = control.label(this.config);
                if (control.type === 'checkbox') element.setAttribute('label', labelText);
                else if (control.type === 'group') element.setAttribute('legend', labelText);
                else if (labelEl) labelEl.innerText = labelText;
            }
            if (control.type === 'group') this.updateControlsLabels(control.children);
        });
    }
    updateControlsVisibility(controlsConfig) {
        (controlsConfig ?? this.controlsConfig).forEach((control)=>{
            if (control.show) {
                const shouldShowControl = control.show(this.config);
                const controlEl = this.controlElements[control.key].element;
                if (controlEl) (0, $82491cd867e5eaaf$export$1a3b688c8bc0de17)(controlEl, !shouldShowControl);
            }
            if (control.isDisabled) {
                const shouldDisableControl = control.isDisabled(this.config);
                const inputEl = this.controlElements[control.key].input;
                if (inputEl) {
                    if (shouldDisableControl) inputEl.setAttribute('disabled', 'disabled');
                    else inputEl.removeAttribute('disabled');
                }
            }
            if (control.children) this.updateControlsVisibility(control.children);
        });
    }
    renderControls(containerEl = this.controlsElement, _controlsConfig, indexStart) {
        const controlsConfig = _controlsConfig ?? this.controlsConfig;
        containerEl.innerHTML = '';
        const controlsFragment = document.createDocumentFragment();
        indexStart = indexStart ?? 1;
        controlsConfig.forEach((controlConfig, controlIndex)=>{
            const controlId = `config_${String(controlConfig.key)}`;
            let controlEl;
            let inputEl;
            let displayValueElement;
            let label;
            if (controlConfig.type === 'group') {
                controlEl = document.createElement('expandable-panel');
                controlEl.setAttribute('legend', this.getConfigValue(controlConfig.label, this.config));
                controlEl.setAttribute('data-group', String(controlConfig.key));
                controlEl.className = 'control control_group';
                if (controlConfig.defaultValue === 'minimized') {
                    controlEl.setAttribute('minimized', 'minimized');
                    this.state.groups[String(controlConfig.key)] = false;
                }
                this.renderControls(controlEl, controlConfig.children);
            } else {
                controlEl = document.createElement('div');
                controlEl.className = 'control';
                if (controlConfig.type !== 'checkbox') {
                    label = document.createElement('label');
                    label.innerHTML = this.getConfigValue(controlConfig.label, this.config);
                    label.setAttribute('for', controlId);
                }
                inputEl = document.createElement($83678c3c8d354007$var$getElementTagNameForControlType(controlConfig.type));
                if ($83678c3c8d354007$var$isRangeInput(inputEl)) inputEl.classList.add('range-input');
                inputEl.setAttribute('tabindex', String(controlIndex));
                const inputValue = this.config[controlConfig.key] ?? this.getConfigValue(controlConfig.defaultValue, this.config);
                if (controlConfig.type === 'select') {
                    const selectOptions = document.createDocumentFragment();
                    controlConfig.options.forEach((_option)=>{
                        const { value: value, label: label } = typeof _option === 'string' ? {
                            value: _option,
                            label: _option
                        } : _option;
                        const optionEl = document.createElement('option');
                        optionEl.setAttribute('value', value);
                        optionEl.innerText = label;
                        selectOptions.appendChild(optionEl);
                    });
                    inputEl.appendChild(selectOptions);
                    inputEl.value = String(inputValue);
                    controlEl.appendChild(label);
                    controlEl.appendChild(inputEl);
                } else {
                    if (controlConfig.type !== 'range') inputEl.setAttribute('type', controlConfig.type);
                    if (controlConfig.type === 'checkbox') {
                        inputEl.checked = !!inputValue;
                        inputEl.setAttribute('label', this.getConfigValue(controlConfig.label, this.config));
                        controlEl.appendChild(inputEl);
                    } else {
                        controlEl.appendChild(label);
                        controlEl.appendChild(inputEl);
                        setTimeout(()=>{
                            inputEl.value = String(inputValue);
                        });
                        displayValueElement = document.createElement('span');
                        displayValueElement.id = `config_${String(controlConfig.key)}_value`;
                        displayValueElement.innerText = String(controlConfig.displayValue ? controlConfig.displayValue(this.config) : inputValue);
                        displayValueElement.className = 'control_input_value';
                        controlEl.appendChild(displayValueElement);
                    }
                }
                if (controlConfig.attr) Object.entries(controlConfig.attr).forEach(([attr, value])=>{
                    const realValue = this.getConfigValue(value, this.config);
                    inputEl.setAttribute(attr, String(realValue));
                });
                inputEl.id = controlId;
            }
            this.controlElements[controlConfig.key] = {
                config: controlConfig,
                displayValueElement: displayValueElement,
                input: inputEl,
                element: controlEl,
                label: label
            };
            controlEl.id = `control_${String(controlConfig.key)}`;
            controlsFragment.appendChild(controlEl);
        });
        containerEl.appendChild(controlsFragment);
        this.updateGroupsState();
        requestAnimationFrame(()=>this.updateControlsVisibility());
    }
    updateGroupsState() {
        const groups = this.controlsElement.querySelectorAll('[data-group]');
        groups.forEach((groupEl)=>{
            if (groupEl instanceof HTMLFieldSetElement) {
                const groupId = groupEl.dataset.group;
                const groupState = this.state.groups[groupId];
                if (typeof groupState === 'boolean') {
                    if (groupState) groupEl.classList.remove('minimized');
                    else groupEl.classList.add('minimized');
                }
            }
        });
    }
    getConfigValue(valueOrFn, config) {
        if (valueOrFn instanceof Function) return valueOrFn(config);
        return valueOrFn;
    }
}
function $83678c3c8d354007$var$getInputValue(inputElement) {
    if ($83678c3c8d354007$var$isRangeInput(inputElement)) return Number(inputElement.value);
    if (inputElement instanceof HTMLInputElement) {
        const type = inputElement.type;
        switch(type){
            case 'range':
                return parseFloat(inputElement.value);
            case 'hue':
                return inputElement.value;
            case 'checkbox':
                return inputElement.checked;
            case 'number':
                return parseFloat(inputElement.value);
            default:
                return inputElement.value;
        }
    } else if (inputElement instanceof (0, $3ce3bee09e11519c$export$2e2bcd8739ae039)) return inputElement.checked;
    else if (inputElement instanceof HTMLSelectElement) return inputElement.value;
}
function $83678c3c8d354007$var$getElementTagNameForControlType(controlType) {
    switch(controlType){
        case 'select':
            return 'select';
        case 'range':
            return 'string-art-range-input';
        case 'hue':
            return 'string-art-hue-input';
        case 'checkbox':
            return 'string-art-checkbox';
        default:
            return 'input';
    }
}
function $83678c3c8d354007$var$isRangeInput(element) {
    return element instanceof (0, $01dabe55fddff864$export$2e2bcd8739ae039) || element instanceof (0, $c6b5ffbe96e4aeb4$export$2e2bcd8739ae039);
}


const $dd4b9b9bb29522b7$var$graphControls = [
    {
        key: 'charge',
        type: 'range',
        label: 'Charge',
        attr: {
            min: 0,
            max: 300,
            step: 1
        },
        defaultValue: 30,
        isStructural: true
    },
    {
        key: 'gravityForce',
        type: 'range',
        label: 'Central gravity',
        attr: {
            min: 0,
            max: 1,
            step: 0.001
        },
        defaultValue: 0.01,
        isStructural: true
    },
    {
        key: 'collisionStrength',
        type: 'range',
        label: 'Collision force strength',
        attr: {
            min: 0,
            max: 1,
            step: 0.01
        },
        defaultValue: 0.1,
        isStructural: true
    },
    {
        key: 'minEnergy',
        type: 'range',
        label: 'Minumum energy',
        attr: {
            min: 0,
            max: 10,
            step: 0.01
        },
        defaultValue: 0.2,
        isStructural: true
    },
    {
        key: 'linkLength',
        type: 'range',
        label: 'Link length',
        attr: {
            min: 1,
            max: 100,
            step: 1
        },
        defaultValue: 15,
        isStructural: true
    },
    {
        key: 'iterations',
        type: 'range',
        label: 'Link rigidity',
        attr: {
            min: 1,
            max: 20,
            step: 1
        },
        defaultValue: 1,
        isStructural: true
    },
    {
        key: 'autoLinkStrength',
        type: 'checkbox',
        label: 'Auto link strength',
        defaultValue: true
    },
    {
        key: 'linkStrength',
        type: 'range',
        label: 'Link strength',
        attr: {
            min: 0.01,
            max: 1,
            step: 0.01
        },
        show: ({ autoLinkStrength: autoLinkStrength })=>!autoLinkStrength,
        defaultValue: 1,
        isStructural: true
    },
    {
        key: 'alphaMin',
        type: 'range',
        label: 'Minimum alpha',
        attr: {
            min: 0,
            max: 0.9,
            step: 0.001
        },
        defaultValue: 0.001,
        isStructural: true
    },
    {
        key: 'friction',
        type: 'range',
        label: 'Friction',
        attr: {
            min: 0,
            max: 0.9,
            step: 0.01
        },
        defaultValue: 0.4,
        isStructural: true
    },
    {
        key: 'minDistance',
        type: 'range',
        label: 'Min distance',
        description: 'The smallest distance between two nodes to use when calculating the force between them',
        attr: {
            min: 0,
            max: 200,
            step: 1
        },
        defaultValue: 10,
        isStructural: true
    },
    {
        key: 'warmupIterations',
        type: 'range',
        label: 'Warmup iterations',
        attr: {
            min: 0,
            max: 150,
            step: 1
        },
        defaultValue: 0,
        isStructural: true
    },
    {
        key: 'randomizePositions',
        type: 'checkbox',
        label: 'Randomize positions',
        defaultValue: false
    },
    {
        key: 'useQuadTree',
        type: 'checkbox',
        label: 'Use quadtree',
        defaultValue: true
    },
    {
        key: 'minQuadSize',
        type: 'range',
        label: 'Min quad size',
        attr: {
            min: 0,
            max: 50,
            step: 1
        },
        defaultValue: 1,
        isStructural: true,
        show: ({ useQuadTree: useQuadTree })=>useQuadTree
    },
    {
        key: 'theta',
        type: 'range',
        label: 'Theta',
        attr: {
            min: 0,
            max: 2,
            step: 0.01,
            snap: '1'
        },
        defaultValue: 1,
        isStructural: true,
        show: ({ useQuadTree: useQuadTree })=>useQuadTree
    },
    {
        key: 'animate',
        type: 'checkbox',
        label: 'Animate',
        defaultValue: true,
        isStructural: false
    }
];
var $dd4b9b9bb29522b7$export$2e2bcd8739ae039 = $dd4b9b9bb29522b7$var$graphControls;




class $7cc03cedd0e1fd58$var$DataControls extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    currentData;
    dataSelectEl;
    constructor(){
        super();
        this.dataSelectEl = document.querySelector('#test_data');
        this.dataSelectEl.addEventListener('change', ()=>{
            this.setData(this.dataSelectEl.value);
        });
        this.init();
    }
    setData(dataId, notifyChange = true) {
        if (dataId !== this.currentData) {
            this.currentData = dataId;
            this.dataSelectEl.value = dataId;
            if (notifyChange) this.emit('data', (0, $e6b77000f6bff1dd$export$2e2bcd8739ae039).find(({ id: id })=>id === dataId));
        }
    }
    init() {
        (0, $e6b77000f6bff1dd$export$2e2bcd8739ae039).forEach(({ name: name, id: id })=>{
            const option = document.createElement('option');
            option.value = id;
            option.textContent = name;
            this.dataSelectEl.appendChild(option);
        });
    }
}
const $7cc03cedd0e1fd58$var$dataControls = new $7cc03cedd0e1fd58$var$DataControls();
var $7cc03cedd0e1fd58$export$2e2bcd8739ae039 = $7cc03cedd0e1fd58$var$dataControls;



const $197740713904c66b$var$MAX_FLOAT_DECIMALS = 6;
function $197740713904c66b$export$fa8157df3262779b(config, defaultConfig) {
    const nonDefaultConfigValues = Object.entries(config).map(([key, value])=>{
        if (value === defaultConfig[key]) return null;
        if (typeof value === 'boolean') return `!${value ? 1 : 0}`;
        if (typeof value === 'number') return parseFloat(value.toFixed($197740713904c66b$var$MAX_FLOAT_DECIMALS));
        return value;
    });
    while(nonDefaultConfigValues[nonDefaultConfigValues.length - 1] === null)nonDefaultConfigValues.pop();
    if (!nonDefaultConfigValues.length) return '';
    const serializedConfigValues = nonDefaultConfigValues.join('_').replace(/\_{2,}/g, (match)=>'~' + match.length + '_');
    return serializedConfigValues;
}
const $197740713904c66b$var$numberRegExp = /^\-?\d+(\.\d+)?$/;
const $197740713904c66b$var$booleanRegExp = /^(?:!)([01])$/;
function $197740713904c66b$export$39ef19ebad6081a3(defaultConfig, serializedCofig) {
    const serializedConfigValues = serializedCofig.replace(/(?:~)(\d+)(?:_)/g, (_, commaCount)=>new Array(+commaCount).fill('_').join('')).split('_').map((v)=>{
        if (v === '') return null;
        if ($197740713904c66b$var$numberRegExp.test(v)) return parseFloat(v);
        const booleanMatch = v.match($197740713904c66b$var$booleanRegExp);
        if (booleanMatch) return booleanMatch[1] === '1';
        return v;
    });
    const configKeys = Object.keys(defaultConfig);
    return serializedConfigValues.reduce((config, serializedValue, i)=>{
        if (serializedValue !== null) {
            const key = configKeys[i];
            return {
                ...config,
                [key]: serializedValue
            };
        }
        return config;
    }, {});
}



class $43e4d7ec12e9791c$var$Routing extends (0, $91e564d7eb822e04$export$2e2bcd8739ae039) {
    #popStateListener;
    #currentData;
    #currentConfig;
    constructor(){
        super();
        const onPopState = this.#popStateListener = ({ state: state })=>{
            this.#updateFromState(state ?? {});
        };
        window.addEventListener('popstate', onPopState);
        this.init();
    }
    get state() {
        return {
            data: this.#currentData,
            config: this.#currentConfig ? (0, $197740713904c66b$export$39ef19ebad6081a3)((0, $896623c33dc7f737$export$2e2bcd8739ae039).defaultConfig, this.#currentConfig) : undefined
        };
    }
    #updateFromState(state) {
        const { config: config, data: data } = state;
        if (data !== this.#currentData) {
            this.#currentData = data;
            this.emit('data', data);
        }
        if (config && config !== this.#currentConfig) {
            this.#currentConfig = config;
            this.emit('config', (0, $197740713904c66b$export$39ef19ebad6081a3)((0, $896623c33dc7f737$export$2e2bcd8739ae039).defaultConfig, config));
        }
    }
    init() {
        if (history.state?.data || history.state?.config) this.#updateFromState(history.state);
        else {
            const queryParams = new URLSearchParams(document.location.search);
            this.#updateFromState({
                data: queryParams.get('data'),
                config: queryParams.get('config')
            });
        }
    }
    destroy() {
        window.removeEventListener('popstate', this.#popStateListener);
    }
    navigate({ data: data, config: config, replaceState: replaceState = false } = {}) {
        const configQuery = (0, $197740713904c66b$export$fa8157df3262779b)(config ?? {}, (0, $896623c33dc7f737$export$2e2bcd8739ae039).defaultConfig);
        const setHistoryState = (replaceState ? history.replaceState : history.pushState).bind(history);
        const urlParams = new URLSearchParams();
        if (data ?? this.#currentData) {
            urlParams.set('data', data ?? this.#currentData);
            if (data) this.#currentData = data;
        }
        if (configQuery) urlParams.set('config', configQuery);
        setHistoryState({
            data: data ?? this.#currentData,
            config: configQuery
        }, data, '?' + urlParams.toString());
    }
}
const $43e4d7ec12e9791c$var$routing = new $43e4d7ec12e9791c$var$Routing();
var $43e4d7ec12e9791c$export$2e2bcd8739ae039 = $43e4d7ec12e9791c$var$routing;


const $079a08596a3503eb$var$graphRenderControls = [
    {
        key: 'nodeRadius',
        type: 'range',
        label: 'Node radius',
        attr: {
            min: 1,
            max: 50,
            step: 0.5
        },
        defaultValue: 5,
        isStructural: true
    },
    {
        key: 'linkColor',
        type: 'color',
        label: 'Link color'
    },
    {
        key: 'fixNodesOnDrag',
        type: 'checkbox',
        label: 'Fix nodes on drag',
        defaultValue: true
    }
];
var $079a08596a3503eb$export$2e2bcd8739ae039 = $079a08596a3503eb$var$graphRenderControls;



class $5a3fbecd13211ffc$export$2e2bcd8739ae039 extends (0, $d641d6dd3c1f4acb$export$2e2bcd8739ae039) {
    constructor(data){
        super(data);
    }
    add(...nodes) {
        this.data.nodes.push(...nodes);
        this.emit('add', nodes);
    }
    remove(...nodeIndexes) {
        const indexesSet = new Set(nodeIndexes.filter((index)=>index < this.data.nodes.length));
        if (!indexesSet.size) return;
        const indexesToRemove = Array.from(indexesSet).sort();
        for(let index = indexesToRemove.length - 1; index >= 0; index--)this.data.nodes.splice(index, 1);
        this.emit('remove', {
            removedIndexes: indexesToRemove
        });
    }
}


window.addEventListener('load', $1ccc8d3c866b7484$var$main);
function $1ccc8d3c866b7484$var$main() {
    const rect = document.querySelector('#graph').getBoundingClientRect();
    const dataProvider = new (0, $5a3fbecd13211ffc$export$2e2bcd8739ae039)({
        nodes: [],
        links: []
    });
    const { data: routingData, config: routingConfig } = (0, $43e4d7ec12e9791c$export$2e2bcd8739ae039).state;
    const graph = new (0, $896623c33dc7f737$export$2e2bcd8739ae039)([
        rect.width,
        rect.height
    ], {
        ...routingConfig,
        radius: ({ radius: radius })=>Math.max(3, radius ?? 4)
    }, dataProvider);
    const canvasGraph = new (0, $326a3135f3ea9288$export$2e2bcd8739ae039)(graph, document.querySelector('#graph'), {
        nodeColorDimension: 'group'
    });
    canvasGraph.on('click', (e)=>{
        dataProvider.add({
            x: e.x,
            y: e.y,
            id: +new Date()
        });
    });
    (0, $43e4d7ec12e9791c$export$2e2bcd8739ae039).on('data', (data)=>(0, $7cc03cedd0e1fd58$export$2e2bcd8739ae039).setData(data));
    (0, $43e4d7ec12e9791c$export$2e2bcd8739ae039).on('config', (config)=>{
        graph.assignConfig(config);
    });
    initConfigControls();
    document.querySelector('#reset_btn').addEventListener('click', ()=>graph.reset());
    document.querySelector('#unfix_btn').addEventListener('click', ()=>graph.unfixAllNodePositions());
    function initConfigControls() {
        function getRoutingConfig() {
            const routingConfig = {
                ...graph.config
            };
            for(const k in graph.config)if (graph.config[k] instanceof Function) routingConfig[k] = (0, $896623c33dc7f737$export$2e2bcd8739ae039).defaultConfig[k];
            return routingConfig;
        }
        const controls = new (0, $83678c3c8d354007$export$2e2bcd8739ae039)(document.querySelector('#graph_controls'), (0, $dd4b9b9bb29522b7$export$2e2bcd8739ae039), graph.config);
        const renderControls = new (0, $83678c3c8d354007$export$2e2bcd8739ae039)(document.querySelector('#render_controls'), (0, $079a08596a3503eb$export$2e2bcd8739ae039), canvasGraph.config);
        controls.on('input', ({ control: control, value: value })=>{
            graph.setConfigValue(control.key, value);
            controls.config = graph.config;
        });
        controls.on('change', ()=>{
            (0, $43e4d7ec12e9791c$export$2e2bcd8739ae039).navigate({
                config: getRoutingConfig()
            });
        });
        renderControls.on('input', ({ control: control, value: value })=>{
            canvasGraph.setConfigValue(control.key, value);
            renderControls.config = canvasGraph.config;
        });
        (0, $7cc03cedd0e1fd58$export$2e2bcd8739ae039).on('data', ({ id: id, data: data })=>{
            (0, $43e4d7ec12e9791c$export$2e2bcd8739ae039).navigate({
                data: id,
                config: getRoutingConfig()
            });
            dataProvider.setData(data);
        });
        if (routingData) (0, $7cc03cedd0e1fd58$export$2e2bcd8739ae039).setData(routingData);
        else (0, $7cc03cedd0e1fd58$export$2e2bcd8739ae039).setData((0, $e6b77000f6bff1dd$export$2e2bcd8739ae039)[0].id);
    }
}


//# sourceMappingURL=graph.19833d2f.js.map
